"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7346],{

/***/ 17562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_breadcrumbs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23018);
/* harmony import */ var _icon_ArrowBack__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93303);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2080);
/* harmony import */ var _P2_P2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72560);
/* harmony import */ var _Link_Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76356);
/* harmony import */ var _IconButton_IconButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42531);









var BreadCrumb = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "ezseds00",
    label: "BreadCrumb"
})("border:1px solid var(--color-divider);");
var StyledCrumbs = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(BreadCrumb, {
    target: "ezseds01",
    label: "StyledCrumbs"
})("padding:", function(param) {
    var $padding = param.$padding;
    return $padding;
}, ";transform:skew(-20deg);height:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_8B */ .t8.B3, ";background-color:var(--color-base-1);margin:auto ", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_6 */ .t8.A1, ";cursor:pointer;border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_2B */ .t8.Rw, ";@media only screen and (max-width:47.95em){display:none;}");
var Unskew = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_P2_P2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    target: "ezseds02",
    label: "Unskew"
})("transform:skew(20deg);color:var(--color-text-primary);white-space:nowrap;text-overflow:ellipsis;max-width:280px;overflow:hidden;");
var Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "ezseds03",
    label: "Wrapper"
})("display:flex;-ms-overflow-style:none;scrollbar-width:none;overflow:auto;&::-webkit-scrollbar{display:none;}");
var BackButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    target: "ezseds04",
    label: "BackButton"
})("margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_3B */ .t8.N, ";box-shadow:none;background-color:var(--color-base-1);");
var BreadCrumbs = function(param) {
    var tags = param.tags, className = param.className, onBackClick = param.onBackClick, useBackClick = param.useBackClick, padding = param.padding;
    var tagsLength = (tags === null || tags === void 0 ? void 0 : tags.length) || 0;
    var lastLink = tagsLength > 0 && !useBackClick ? tags === null || tags === void 0 ? void 0 : tags[tagsLength - 1] : null;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(Wrapper, {
        className: className,
        children: [
            lastLink ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_Link_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                href: lastLink.href,
                as: lastLink.as,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(BreadCrumb, {
                    as: BackButton,
                    bgColor: "var(--color-base-0)",
                    hovDisabled: true,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_icon_ArrowBack__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        size: _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_4B */ .t8.BM,
                        color: "var(--color-text-primary)"
                    })
                })
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(BreadCrumb, {
                as: BackButton,
                onClick: onBackClick,
                bgColor: "var(--color-base-0)",
                hovDisabled: true,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_icon_ArrowBack__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    size: _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_4B */ .t8.BM,
                    color: "var(--color-text-primary)"
                })
            }),
            tags === null || tags === void 0 ? void 0 : tags.map(function(tag) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(StyledCrumbs, {
                    $padding: padding,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_Link_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        href: tag.href,
                        as: tag.as,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(Unskew, {
                            children: tag.title
                        })
                    })
                }, tag.title);
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumbs);
BreadCrumbs.propTypes = {
    padding: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    tags: prop_types__WEBPACK_IMPORTED_MODULE_8___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_8___default().shape({
        title: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string.isRequired),
        as: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
        href: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string.isRequired)
    })),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    onBackClick: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().func),
    useBackClick: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool)
};
BreadCrumbs.defaultProps = {
    padding: "".concat(_styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_2B */ .t8.Rw, " ").concat(_styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_5B */ .t8.zj),
    className: "",
    tags: [],
    onBackClick: _utils_breadcrumbs__WEBPACK_IMPORTED_MODULE_1__/* .goBack */ .Hm,
    useBackClick: false
};


/***/ }),

/***/ 52236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);



var getStyling = function(type) {
    var styling = {
        filled: {
            Bg: "var(--color-base-fill)",
            Text: "var(--color-base-1)",
            paddingHorizontal: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_2B */ .t8.Rw,
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.H7 */ .F3.H7
        },
        hollow: {
            Bg: "var(--color-shadow)",
            Text: "var(--color-text-primary)",
            paddingHorizontal: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_6 */ .t8.A1,
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.EXTRA_SMALL */ .F3.y2
        },
        transparent: {
            Bg: "var(--color-base-1)",
            Text: "var(--color-i-blue)",
            paddingHorizontal: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_0B */ .t8.NE,
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.H7 */ .F3.H7
        },
        live: {
            Bg: "var(--color-i-red)",
            Text: "var(--color-i-white)",
            paddingHorizontal: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_2B */ .t8.Rw,
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.H7 */ .F3.H7
        },
        disabled: {
            Bg: "var(--color-base-1)",
            Text: "var(--color-text-secondary)",
            paddingHorizontal: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_0B */ .t8.NE,
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.EXTRA_SMALL */ .F3.y2
        },
        discount: {
            Bg: "var(--color-i-orange-16)",
            Text: "var(--color-i-orange-1)",
            paddingHorizontal: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_2B */ .t8.Rw,
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.H7 */ .F3.H7
        },
        alert: {
            Bg: "var(--color-base-1)",
            Text: "var(--color-i-red)",
            paddingHorizontal: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_0B */ .t8.NE,
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.H7 */ .F3.H7
        },
        success: {
            Bg: "var(--color-i-green)",
            Text: "var(--color-base-1)",
            paddingHorizontal: "10px",
            fontSize: _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.EXTRA_SMALL */ .F3.y2
        }
    };
    return styling[type];
};
var semiBold = [
    "filled",
    "live",
    "alert"
];
var Tags = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("span", {
    target: "e13dpfl00",
    label: "Tags"
})("background-color:", function(param) {
    var type = param.type, bgColor = param.bgColor;
    var ref;
    return bgColor || ((ref = getStyling(type)) === null || ref === void 0 ? void 0 : ref.Bg);
}, ";color:", function(param) {
    var type = param.type;
    var ref;
    return (ref = getStyling(type)) === null || ref === void 0 ? void 0 : ref.Text;
}, ";font-size:", function(param) {
    var type = param.type;
    return getStyling(type).fontSize;
}, ";font-weight:", function(param) {
    var type = param.type;
    return semiBold.includes(type) ? _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.SEMIBOLD */ .F3.rX : _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.BOLD */ .F3.Pl;
}, ";padding:", function(param) {
    var type = param.type;
    var ref;
    return "".concat(_styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_6 */ .t8.A1, " ").concat((ref = getStyling(type)) === null || ref === void 0 ? void 0 : ref.paddingHorizontal);
}, ";border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_1B */ .t8.MK, ";display:inline-block;text-transform:uppercase;line-height:1;");
/* harmony default export */ __webpack_exports__["Z"] = (Tags);
Tags.propTypes = {
    type: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf([
        "filled",
        "hollow",
        "transparent",
        "live",
        "disabled",
        "discount",
        "alert",
        "success"
    ]),
    bgColor: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
Tags.defaultProps = {
    type: "transparent",
    bgColor: null
};


/***/ }),

/***/ 96794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _base_H3_H3__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82034);
/* harmony import */ var _base_Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35415);
/* harmony import */ var _base_P1_P1__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85620);
/* harmony import */ var _utils_imageHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48821);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97428);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31309);
/* harmony import */ var _utils_pushRoute__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(751);
/* harmony import */ var _events_sendAnalytics__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99691);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2080);












var SPACING_2B = _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_2B */ .t8.Rw, SPACING_7B = _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_7B */ .t8.d5, SPACING_10B = _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_10B */ .t8.FC, SPACING_3B = _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_3B */ .t8.N, SPACING_4B = _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_4B */ .t8.BM, SPACING_6B = _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_6B */ .t8.BY;
var images = {
    25: {
        image: "25percent.svg",
        background: {
            0: "zigzagRed.svg",
            1: "zigzagOrange.svg",
            2: "zigzagBlue.svg",
            3: "zigzagBlue.svg"
        }
    },
    20: {
        left: {
            0: "alarmRed.svg",
            1: "alarmOrange.svg",
            2: "alarmBlue.svg",
            3: "alarmBlue.svg",
            4: "alarmBlue.svg",
            5: "alarmBlue.svg"
        },
        background: {
            0: "zigzagRed.svg",
            1: "zigzagOrange.svg",
            2: "zigzagBlue.svg",
            3: "zigzagBlue.svg",
            4: "zigzagBlue.svg",
            5: "zigzagBlue.svg"
        }
    },
    15: {
        left: {
            0: "alarmRed.svg",
            1: "1day.svg",
            2: "2days.svg",
            3: "3days.svg",
            4: "4days.svg",
            5: "5days.svg",
            6: "6days.svg",
            7: "7days.svg"
        },
        background: {
            0: "zigzagRed.svg",
            1: "zigzagOrange.svg",
            2: "zigzagBlue.svg",
            3: "zigzagBlue.svg",
            4: "zigzagBlue.svg",
            5: "zigzagBlue.svg",
            6: "zigzagBlue.svg",
            7: "zigzagBlue.svg"
        }
    }
};
var getBackgroundColor = function(percentage, daysRemaining) {
    if (percentage === 25 || percentage === 20 || percentage === 15) {
        if (daysRemaining === 0) return "var(--color-i-red)";
        if (daysRemaining === 1) return "var(--color-i-orange-1)";
    }
    return "var(--color-i-blue)";
};
var Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "eop7hok0",
    label: "Wrapper"
})("grid-column:", function(param) {
    var $gridColumn = param.$gridColumn;
    return $gridColumn;
}, ";border-radius:", SPACING_2B, ";height:", function(param) {
    var $small = param.$small;
    return $small ? "216px" : "248px";
}, ";overflow:hidden;position:relative;display:flex;padding:", SPACING_7B, " ", SPACING_10B, " ", SPACING_7B, " ", SPACING_7B, ";> *{position:relative;}");
var WrapperBg = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "eop7hok1",
    label: "WrapperBg"
})("position:absolute;left:0;top:0;width:100%;height:100%;border-radius:", SPACING_2B, ";background-color:", function(param) {
    var $percentage = param.$percentage, $daysRemaining = param.$daysRemaining;
    return getBackgroundColor($percentage, $daysRemaining);
}, ";opacity:0.15;");
var Image = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("img", {
    target: "eop7hok2",
    label: "Image"
})("position:absolute;left:", function(param) {
    var $small = param.$small;
    return $small ? "29px" : "35px";
}, ";height:", function(param) {
    var $small = param.$small;
    return $small && "159px";
}, ";width:", function(param) {
    var $small = param.$small;
    return $small && "159px";
}, ";");
var Calendar = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("img", {
    target: "eop7hok3",
    label: "Calendar"
})("position:absolute;left:", function(param) {
    var $small = param.$small;
    return $small ? "29px" : "8px";
}, ";top:", function(param) {
    var $small = param.$small;
    return !$small && 0;
}, ";height:", function(param) {
    var $small = param.$small;
    return $small && "190px";
}, ";width:", function(param) {
    var $small = param.$small;
    return $small && "190px";
}, ";");
var Content = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_P1_P1__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    target: "eop7hok4",
    label: "Content"
})("font-size:", function(param) {
    var $small = param.$small;
    return $small && "12px";
}, ";margin-bottom:", SPACING_6B, ";");
var Highlight = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("span", {
    target: "eop7hok5",
    label: "Highlight"
})("font-weight:600;");
var Header = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_H3_H3__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "eop7hok6",
    label: "Header"
})("font-weight:", function(param) {
    var $small = param.$small;
    return $small && "600";
}, ";font-size:", function(param) {
    var $small = param.$small;
    return $small && "16px";
}, ";line-height:", function(param) {
    var $small = param.$small;
    return $small && "150%";
}, ";margin-top:", SPACING_3B, ";margin-bottom:", function(param) {
    var $small = param.$small;
    return $small ? SPACING_2B : SPACING_4B;
}, ";");
var Code = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "eop7hok7",
    label: "Code"
})("margin-left:", function(param) {
    var $small = param.$small;
    return $small ? "211px" : "262px";
}, ";");
var Img = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("img", {
    target: "eop7hok8",
    label: "Img"
})("position:absolute;height:", function(param) {
    var $small = param.$small;
    return $small ? "216px" : "248px";
}, ";top:0;");
var Zig = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(Img, {
    target: "eop7hok9",
    label: "Zig"
})("left:0;");
var Zag = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(Img, {
    target: "eop7hok10",
    label: "Zag"
})("right:0;transform:scaleX(-1);");
var renderLeft = function(percentage, daysRemaining, small) {
    if (percentage === 15) {
        var ref;
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(Calendar, {
            src: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_4__/* .getImage */ .gJ)((ref = images[15].left) === null || ref === void 0 ? void 0 : ref[daysRemaining]),
            $small: small
        });
    }
    if (percentage === 20) {
        var ref1;
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(Image, {
            src: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_4__/* .getImage */ .gJ)((ref1 = images[20].left) === null || ref1 === void 0 ? void 0 : ref1[daysRemaining]),
            $small: small,
            alt: "days remaining"
        });
    }
    if (percentage === 25) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(Image, {
            src: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_4__/* .getImage */ .gJ)(images[25].image),
            $small: small,
            alt: "days remaining"
        });
    }
};
var Left = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "eop7hok11",
    label: "Left"
})("width:", function(param) {
    var $small = param.$small;
    return $small ? "283px" : "330px";
}, ";height:", function(param) {
    var $small = param.$small;
    return $small ? "262px" : "330px";
}, ";position:absolute;left:", function(param) {
    var $small = param.$small;
    return $small ? "-96px" : "-84px";
}, ";top:", function(param) {
    var $small = param.$small;
    return $small ? "-29px" : "-35px";
}, ";border-radius:50%;");
var ExtendButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    target: "eop7hok12",
    label: "ExtendButton"
})("&:hover{box-shadow:none;}&:active{box-shadow:none;}");
var RenewalCard = function(param) {
    var gridColumn = param.gridColumn, data = param.data, subscription = param.subscription, className = param.className, small = param.small, lastPrimarySource = param.lastPrimarySource;
    var ref, ref1;
    var ref2 = data || {}, code = ref2.code, show = ref2.show, maxDiscount = ref2.maxDiscount, validTill = ref2.validTill, percentage = ref2.percentage, daysRemaining = ref2.daysRemaining;
    if (!show) return null;
    var days = daysRemaining;
    if (percentage === 20 && daysRemaining > 5) days = 5;
    if (percentage === 15 && daysRemaining > 7) days = 7;
    var handleClick = function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var duration = _utils_textHelper__WEBPACK_IMPORTED_MODULE_6__/* ["default"].getHigherSubscription */ .ZP.getHigherSubscription(Math.floor((subscription === null || subscription === void 0 ? void 0 : (ref = subscription.subscription) === null || ref === void 0 ? void 0 : ref.duration) / 30));
        (0,_utils_pushRoute__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            pathname: "/goal/[goalSlug]/[goalUID]/subscribe",
            query: {
                referral_code: encodeURIComponent(code || ""),
                duration: duration
            }
        }, "".concat((subscription === null || subscription === void 0 ? void 0 : (ref1 = subscription.subscription) === null || ref1 === void 0 ? void 0 : ref1.value.relative_link) || (subscription === null || subscription === void 0 ? void 0 : (ref2 = subscription.subscription) === null || ref2 === void 0 ? void 0 : ref2.value.relativeLink), "/subscribe/?referral_code=").concat(encodeURIComponent(code || ""), "&duration=").concat(duration));
        (0,_events_sendAnalytics__WEBPACK_IMPORTED_MODULE_8__/* .sendExtendSubscriptionEvent */ .H3)(subscription === null || subscription === void 0 ? void 0 : (ref3 = subscription.subscription) === null || ref3 === void 0 ? void 0 : ref3.value.uid, subscription === null || subscription === void 0 ? void 0 : (ref4 = subscription.subscription) === null || ref4 === void 0 ? void 0 : ref4.value.name, subscription === null || subscription === void 0 ? void 0 : (ref5 = subscription.subscription) === null || ref5 === void 0 ? void 0 : ref5.type, lastPrimarySource);
    };
    if (percentage) return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(Wrapper, {
        $gridColumn: gridColumn,
        className: className,
        $small: small,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(WrapperBg, {
                $percentage: percentage,
                $daysRemaining: days
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(Left, {
                $percentage: percentage,
                $daysRemaining: days,
                $small: small
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(Zig, {
                src: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_4__/* .getImage */ .gJ)((ref = images[percentage]) === null || ref === void 0 ? void 0 : ref.background[days]),
                $small: small
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(Zag, {
                src: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_4__/* .getImage */ .gJ)((ref1 = images[percentage]) === null || ref1 === void 0 ? void 0 : ref1.background[days]),
                $small: small
            }),
            renderLeft(percentage, days, small),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(Code, {
                $small: small,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(Header, {
                        $small: small,
                        children: percentage === 15 && daysRemaining === 0 ? "Your subscription is expiring today" : "Extend now and Save ".concat(percentage, "%")
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsxs */ .BX)(Content, {
                        $small: small,
                        children: [
                            "Use code",
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(Highlight, {
                                children: " ".concat(code, " ")
                            }),
                            "and save upto Rs ".concat((0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_6__/* .commas */ .q1)(maxDiscount), " when you extend your subscription."),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(Highlight, {
                                children: percentage !== 15 ? " Valid till ".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_5__/* .getFullDate */ .xE)(validTill), ".") : null
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(ExtendButton, {
                        label: "Extend Subscription",
                        onClick: handleClick
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RenewalCard);
RenewalCard.propTypes = {
    gridColumn: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().string),
    data: prop_types__WEBPACK_IMPORTED_MODULE_11___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_11___default().any)),
    subscription: prop_types__WEBPACK_IMPORTED_MODULE_11___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_11___default().any)),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_11___default().string)
};
RenewalCard.defaultProps = {
    gridColumn: "span 18",
    data: {},
    subscription: {},
    className: ""
};


/***/ }),

/***/ 65840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$3": function() { return /* binding */ getIsMenuHide; },
/* harmony export */   "Gj": function() { return /* binding */ getBatchTypeByFilterOptions; },
/* harmony export */   "Ph": function() { return /* binding */ getJoinBatchLabel; },
/* harmony export */   "RF": function() { return /* binding */ getMessageWithDate; },
/* harmony export */   "Y3": function() { return /* binding */ getSlashPriceMessage; },
/* harmony export */   "Yw": function() { return /* binding */ getDarkModeImage; },
/* harmony export */   "a5": function() { return /* binding */ getActiveStatus; },
/* harmony export */   "aw": function() { return /* binding */ getIsBatchCompleted; },
/* harmony export */   "d": function() { return /* binding */ getFontSizeForPrice; },
/* harmony export */   "ec": function() { return /* binding */ getInfoStringForBatchGroup; },
/* harmony export */   "gP": function() { return /* binding */ getCtaState; },
/* harmony export */   "hw": function() { return /* binding */ getTagsConfig; },
/* harmony export */   "qC": function() { return /* binding */ getIsBatchAccessEnded; },
/* harmony export */   "ri": function() { return /* binding */ getEntitySubType; },
/* harmony export */   "u": function() { return /* binding */ getBatchConfig; },
/* harmony export */   "wR": function() { return /* binding */ getIsEnrollmentClosed; },
/* harmony export */   "wS": function() { return /* binding */ getHref; },
/* harmony export */   "x1": function() { return /* binding */ getBusinessPlatform; },
/* harmony export */   "yE": function() { return /* binding */ getShowFeedback; },
/* harmony export */   "ym": function() { return /* binding */ getTabRefs; },
/* harmony export */   "yu": function() { return /* binding */ getLanguagesForCard; }
/* harmony export */ });
/* unused harmony exports getEnrollmentEndMessage, getCardSpecificDetail, getEnrollmentStatusIcon, getCharCount */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29815);
/* harmony import */ var _models_Item__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46571);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47426);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97428);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10736);











var enrollmentClockIcon = "prodigy/enrollment-clock.svg";
var enrollmentEndedIcons = "prodigy/enrollment-end.svg";
var getMessageWithDate = function() {
    var startingText = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", date = arguments.length > 1 ? arguments[1] : void 0;
    if (!date) return null;
    var dateShort = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getDateMonthString */ .$s)(date, false, false);
    var year = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getYear */ .So)(date);
    return "".concat(startingText, " ").concat(dateShort, " ").concat(year);
};
var getIsEnrollmentClosed = function(enrollmentEndDate) {
    if (!enrollmentEndDate) return false;
    var dateDifference = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getDateDifference */ .hM)(enrollmentEndDate);
    return dateDifference <= 0;
};
var getIsBatchCompleted = function(batchEndDate) {
    if (!batchEndDate) return false;
    var dateDifference = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getDateDifference */ .hM)(batchEndDate);
    return dateDifference <= 0;
};
var getIsBatchAccessEnded = function(batchAccessEndDate) {
    if (!batchAccessEndDate) return false;
    var dateDifference = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getDateDifference */ .hM)(batchAccessEndDate);
    return dateDifference <= 0;
};
// TODO  need to handle for PLATINUM BATCH GROUP
var getBusinessPlatform = function(goalData) {
    if (goalData === null || goalData === void 0 ? void 0 : goalData.isPlatformGoal) return _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .businessPlatform.UA_PLATFORM */ .Kr.UA_PLATFORM;
    return _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .businessPlatform.UNACADEMY */ .Kr.UNACADEMY;
};
var getSlashPriceMessage = function(date, promoText, isDiscountAvailable) {
    if (!date || !isDiscountAvailable) return "";
    var relativeDate = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getRelativeDayOrCurrentDateWithTDays */ .Aw)(date, true);
    var isRelativeDateTodayTomorrow = _utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .todayTomorrowConfig.some */ .Wb.some(function(day) {
        return day === relativeDate;
    });
    if (isRelativeDateTodayTomorrow) {
        return promoText || "Discount ends ".concat(relativeDate);
    }
    if (relativeDate <= 7) {
        return promoText || "Discount ends in ".concat(relativeDate, " days");
    }
    return "";
};
var getEnrollmentEndMessage = function(date) {
    if (!date) return "N/A";
    var relativeDate = getRelativeDayOrCurrentDateWithTDays(date, true);
    var isRelativeDateTodayTomorrow = todayTomorrowConfig.some(function(day) {
        return day === relativeDate;
    });
    if (!relativeDate) {
        return "Enrollments have closed for this batch";
    }
    if (isRelativeDateTodayTomorrow) {
        return "Enrollment ends ".concat(relativeDate);
    }
    if (relativeDate <= 7 && relativeDate > 0) {
        return "Enrollment ends in ".concat(relativeDate, " days");
    }
    return "Enrollment ends on ".concat(relativeDate);
};
var getEnrollmentStatusIcon = function(date) {
    if (!date) return "";
    var relativeDate = getRelativeDayOrCurrentDateWithTDays(date, true);
    return relativeDate < 0 ? enrollmentEndedIcons : enrollmentClockIcon;
};
var getCardSpecificDetail = function(enrollmentEndDate, trialClasses) {
    var hasTrailClass = !isEmpty(trialClasses);
    var defaultObject = {
        buttonColor: "var(--color-red-border-focus)",
        textColor: "var(--color-i-red)",
        icon: enrollmentClockIcon
    };
    var isEnrollmentClose = getIsEnrollmentClosed(enrollmentEndDate);
    if (isEnrollmentClose) {
        return _object_spread_props(_object_spread({}, defaultObject), {
            buttonText: "Enrolment closed",
            icon: "calendar-clock.svg",
            buttonColor: "var(--color-base-light-0)",
            textColor: "var(--color-text-secondary)"
        });
    }
    var remainingDaysCount = getDateDifference(enrollmentEndDate);
    // we will only show enroll text if the date difference is <= 7 or it does not has trail classes.
    var showEnrollMessage = remainingDaysCount <= 7 || !hasTrailClass;
    if (showEnrollMessage) {
        return _object_spread_props(_object_spread({}, defaultObject), {
            buttonText: getEnrollmentEndMessage(enrollmentEndDate)
        });
    }
    return _object_spread_props(_object_spread({}, defaultObject), {
        buttonText: (trialClasses === null || trialClasses === void 0 ? void 0 : trialClasses.text) || "Check out trial classes",
        icon: "batch-play-all.svg",
        buttonColor: "var(--color-base-light-0)",
        textColor: "var(--color-text-primary)"
    });
};
var getCharCount = function() {
    var string = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (!string) return 0;
    return string.length;
};
var getFontSizeForPrice = function(price, listPrice, isDiscountAvailable) {
    if (!isDiscountAvailable) return _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.LARGE */ .F3.ln;
    if (getCharCount(price) > 7 || getCharCount(listPrice) > 7) {
        return _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.SMALL */ .F3.HC;
    }
    return _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.LARGE */ .F3.ln;
};
var getHref = function(href, as, isMobile) {
    var data = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], maximumItemNeedToShowSeeAll = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : _constants__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_ITEM_LENGTH_FOR_SEE_ALL */ .Tx;
    var updatedHref = null;
    var updatedAs = null;
    if (isMobile && data.length > _constants__WEBPACK_IMPORTED_MODULE_5__/* .ITEM_TO_SHOW_IN_M_WEB */ .tB || data.length > maximumItemNeedToShowSeeAll) {
        updatedHref = href;
        updatedAs = as;
    }
    return {
        updatedHref: updatedHref,
        updatedAs: updatedAs
    };
};
var getBatchTypeByFilterOptions = function() {
    var filterOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!!(filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.value) && !((filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.value) in _constants__WEBPACK_IMPORTED_MODULE_5__/* .filterType */ .HT)) {
        return "";
    }
    return _constants__WEBPACK_IMPORTED_MODULE_5__/* .filterType */ .HT[filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.value];
};
var getInfoIcon = function() {
    var isDarkModeOn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, stateMetaInfo = arguments.length > 1 ? arguments[1] : void 0;
    var darkModeIcon = (stateMetaInfo === null || stateMetaInfo === void 0 ? void 0 : stateMetaInfo.darkmode_icon) || (stateMetaInfo === null || stateMetaInfo === void 0 ? void 0 : stateMetaInfo.darkmodeIcon);
    if (isDarkModeOn && darkModeIcon) {
        return darkModeIcon;
    }
    return stateMetaInfo === null || stateMetaInfo === void 0 ? void 0 : stateMetaInfo.icon;
};
var getCtaState = function(stateMetaInfo) {
    var isDarkModeOn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var hasCardState = !!(stateMetaInfo === null || stateMetaInfo === void 0 ? void 0 : stateMetaInfo.state);
    if (!hasCardState || !((stateMetaInfo === null || stateMetaInfo === void 0 ? void 0 : stateMetaInfo.state) in _constants__WEBPACK_IMPORTED_MODULE_5__/* .cardCtaConfig */ .Bb)) return null;
    var text = stateMetaInfo.text;
    var infoIcon = getInfoIcon(isDarkModeOn, stateMetaInfo);
    var _state = _constants__WEBPACK_IMPORTED_MODULE_5__/* .cardCtaConfig */ .Bb[stateMetaInfo.state], buttonColor = _state.buttonColor, textColor = _state.textColor;
    return {
        icon: infoIcon,
        text: text,
        buttonColor: buttonColor,
        textColor: textColor
    };
};
var getLanguagesForCard = function() {
    var languages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var languagesToShow = (languages === null || languages === void 0 ? void 0 : languages.length) > _constants__WEBPACK_IMPORTED_MODULE_5__/* .LANGUAGE_COUNT_FOR_CARD */ .Yv ? languages.slice(0, _constants__WEBPACK_IMPORTED_MODULE_5__/* .LANGUAGE_COUNT_FOR_CARD */ .Yv) : languages;
    return languagesToShow;
};
var getBatchConfig = function(type) {
    // it will return the default object in case type is not exist in BATCH_GROUP_TYPE_CONFIG
    if (!(type in _constants__WEBPACK_IMPORTED_MODULE_5__/* .BATCH_GROUP_TYPE_CONFIG */ .Vo)) return _constants__WEBPACK_IMPORTED_MODULE_5__/* .BATCH_GROUP_TYPE_CONFIG["default"] */ .Vo["default"];
    return _constants__WEBPACK_IMPORTED_MODULE_5__/* .BATCH_GROUP_TYPE_CONFIG */ .Vo[type];
};
var getJoinBatchLabel = function(classType) {
    if (!(classType === null || classType === void 0 ? void 0 : classType.key) || !Object.values(_constants__WEBPACK_IMPORTED_MODULE_5__/* .batchGroupType */ .rP).includes(classType === null || classType === void 0 ? void 0 : classType.key)) return "Join batch";
    if ([
        _constants__WEBPACK_IMPORTED_MODULE_5__/* .batchGroupType.LIVE */ .rP.LIVE,
        _constants__WEBPACK_IMPORTED_MODULE_5__/* .batchGroupType.LIVE_AND_RECORDED */ .rP.LIVE_AND_RECORDED
    ].includes(classType === null || classType === void 0 ? void 0 : classType.key)) return "Join batch";
    if ((classType === null || classType === void 0 ? void 0 : classType.key) === _constants__WEBPACK_IMPORTED_MODULE_5__/* .batchGroupType.RECORDED */ .rP.RECORDED) return "Buy now";
};
var getEntitySubType = function(classType) {
    if (!(classType === null || classType === void 0 ? void 0 : classType.key) || !((classType === null || classType === void 0 ? void 0 : classType.key) in _constants__WEBPACK_IMPORTED_MODULE_5__/* .ENTITY_SUB_TYPE */ .lv)) {
        return "Live";
    }
    return _constants__WEBPACK_IMPORTED_MODULE_5__/* .ENTITY_SUB_TYPE */ .lv[classType === null || classType === void 0 ? void 0 : classType.key];
};
var getInfoString = function(lesson) {
    // Cancelled
    var classState = lesson === null || lesson === void 0 ? void 0 : lesson.classState;
    var classType = lesson === null || lesson === void 0 ? void 0 : lesson.classType;
    if (classState === _constants__WEBPACK_IMPORTED_MODULE_5__/* .CLASS_STATE.CANCELLED_STATE */ .gy.CANCELLED_STATE) {
        return "Cancelled";
    }
    if (classState === _constants__WEBPACK_IMPORTED_MODULE_5__/* .CLASS_STATE.LIVE_STATE */ .gy.LIVE_STATE) {
        return "Started at ".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .formatTime */ .mr)(lesson.startedAt || lesson.liveAt));
    }
    // isRescheduled
    if (classState === _constants__WEBPACK_IMPORTED_MODULE_5__/* .CLASS_STATE.RESCHEDULED_STATE */ .gy.RESCHEDULED_STATE) {
        return "Rescheduled to ".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getDateMonthString */ .$s)(lesson.startedAt || lesson.liveAt, false, false), ", ").concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getTime */ .hK)(lesson.startedAt || lesson.liveAt));
    }
    // RECORDED Batch
    if (classType === _constants__WEBPACK_IMPORTED_MODULE_5__/* .batchGroupType.RECORDED */ .rP.RECORDED) {
        // RECORDED Batch + completely watched
        if (classState === _constants__WEBPACK_IMPORTED_MODULE_5__/* .CLASS_STATE.COMPLETELY_WATCHED_STATE */ .gy.COMPLETELY_WATCHED_STATE) return "Completed".concat(_constants__WEBPACK_IMPORTED_MODULE_5__/* .SPACE_WITH_DOT */ .aG).concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getHoursMinutesValueFromSeconds */ .mU)(lesson === null || lesson === void 0 ? void 0 : lesson.lessonDuration));
        return "".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getHoursMinutesValueFromSeconds */ .mU)(lesson === null || lesson === void 0 ? void 0 : lesson.lessonDuration));
    }
    if (classState === _constants__WEBPACK_IMPORTED_MODULE_5__/* .CLASS_STATE.COMPLETELY_WATCHED_STATE */ .gy.COMPLETELY_WATCHED_STATE) {
        return "Completed".concat(_constants__WEBPACK_IMPORTED_MODULE_5__/* .SPACE_WITH_DOT */ .aG, "Ended on ").concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getDateMonthString */ .$s)(lesson === null || lesson === void 0 ? void 0 : lesson.endsAt, false, false));
    }
    if (classState === _constants__WEBPACK_IMPORTED_MODULE_5__/* .CLASS_STATE.NOT_WATCHED_STATE */ .gy.NOT_WATCHED_STATE) {
        return "".concat("Missed ".concat(_constants__WEBPACK_IMPORTED_MODULE_5__/* .SPACE_WITH_DOT */ .aG), "Ended on ").concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getDateMonthString */ .$s)(lesson === null || lesson === void 0 ? void 0 : lesson.endsAt, false, false));
    }
    // live batch Continue Watching
    if (classState === _constants__WEBPACK_IMPORTED_MODULE_5__/* .CLASS_STATE.CONTINUE_WATCH_STATE */ .gy.CONTINUE_WATCH_STATE) {
        return "Ended on ".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getDateMonthString */ .$s)(lesson === null || lesson === void 0 ? void 0 : lesson.endsAt, false, false));
    }
    // upcoming
    return "".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .formatTime */ .mr)(lesson.liveAt));
};
var getInfoStringForBatchGroup = function(lesson) {
    var batchGroupInfoString = getInfoString(lesson);
    return "".concat(batchGroupInfoString).concat(_constants__WEBPACK_IMPORTED_MODULE_5__/* .SPACE_WITH_DOT */ .aG).concat((0,_models_Item__WEBPACK_IMPORTED_MODULE_0__/* .getPersonName */ .rQ)(lesson === null || lesson === void 0 ? void 0 : lesson.author));
};
var getIsMenuHide = function(lesson) {
    return !((lesson === null || lesson === void 0 ? void 0 : lesson.classState) === _constants__WEBPACK_IMPORTED_MODULE_5__/* .CLASS_STATE.LIVE_STATE */ .gy.LIVE_STATE);
};
var getTagsConfig = function() {
    var isEnrolled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (!isEnrolled) {
        var tabConfig = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _constants__WEBPACK_IMPORTED_MODULE_5__/* .defaultTabsConfig */ .MP);
        delete tabConfig[_constants__WEBPACK_IMPORTED_MODULE_5__/* .Sections.ABOUT */ .bx.ABOUT];
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, _constants__WEBPACK_IMPORTED_MODULE_5__/* .Sections.ABOUT */ .bx.ABOUT, {
            label: _constants__WEBPACK_IMPORTED_MODULE_5__/* .tabLabel.ABOUT */ .Jg.ABOUT,
            key: _constants__WEBPACK_IMPORTED_MODULE_5__/* .Sections.ABOUT */ .bx.ABOUT,
            id: 2,
            value: 2
        }), tabConfig);
    }
    return _constants__WEBPACK_IMPORTED_MODULE_5__/* .defaultTabsConfig */ .MP;
};
var getDarkModeImage = function() {
    var isDarkModeOn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, darkModeImage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", image = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    if (isDarkModeOn && darkModeImage) {
        return darkModeImage;
    }
    return image;
};
var getShowFeedback = function() {
    var batchDetails = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    var ref1;
    var isEnrolled = (ref1 = batchDetails === null || batchDetails === void 0 ? void 0 : batchDetails.isEnrolled) !== null && ref1 !== void 0 ? ref1 : false;
    var ref2;
    var isCardAvailable = (ref2 = batchDetails === null || batchDetails === void 0 ? void 0 : (ref = batchDetails.feedbackData) === null || ref === void 0 ? void 0 : ref.is_card_available) !== null && ref2 !== void 0 ? ref2 : false;
    // we will show feedback card when learner is enrolled and have is_card_available key as true.
    return isEnrolled && isCardAvailable;
};
var getTabRefs = function() {
    var isEnrolled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, ref = arguments.length > 1 ? arguments[1] : void 0, scheduleRef = ref.scheduleRef, lessonRef = ref.lessonRef, aboutRef = ref.aboutRef, educatorRef = ref.educatorRef, faqsRef = ref.faqsRef;
    var defaultOrderOfTabs = [
        {
            ref: scheduleRef,
            shrinkPos: _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .scrollConstants.scroll100 */ .CU.scroll100,
            id: _constants__WEBPACK_IMPORTED_MODULE_5__/* .Sections.BATCH_SCHEDULE */ .bx.BATCH_SCHEDULE
        },
        {
            ref: lessonRef,
            shrinkPos: _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .scrollConstants.scroll100 */ .CU.scroll100,
            id: _constants__WEBPACK_IMPORTED_MODULE_5__/* .Sections.LESSONS */ .bx.LESSONS
        },
        {
            ref: educatorRef,
            shrinkPos: _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .scrollConstants.scroll100 */ .CU.scroll100,
            id: _constants__WEBPACK_IMPORTED_MODULE_5__/* .Sections.EDUCATORS */ .bx.EDUCATORS
        },
        {
            ref: aboutRef,
            shrinkPos: _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .scrollConstants.scroll100 */ .CU.scroll100,
            id: _constants__WEBPACK_IMPORTED_MODULE_5__/* .Sections.ABOUT */ .bx.ABOUT
        },
        {
            ref: faqsRef,
            shrinkPos: _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .scrollConstants.scroll280 */ .CU.scroll280,
            id: _constants__WEBPACK_IMPORTED_MODULE_5__/* .Sections.FAQS */ .bx.FAQS
        }
    ];
    if (!isEnrolled) {
        // here we are updating the tabs order moving ABOUT section on top
        var filteredTabs = defaultOrderOfTabs.filter(function(tabObject) {
            return tabObject.id !== _constants__WEBPACK_IMPORTED_MODULE_5__/* .Sections.ABOUT */ .bx.ABOUT;
        });
        return [
            {
                ref: aboutRef,
                shrinkPos: _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .scrollConstants.scroll100 */ .CU.scroll100,
                id: _constants__WEBPACK_IMPORTED_MODULE_5__/* .Sections.ABOUT */ .bx.ABOUT
            }
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(filteredTabs));
    }
    return defaultOrderOfTabs;
};
// we are updating the tab ordering in case of enrolled user
// order of tabRefs should be same with activeStatuses
var getActiveStatus = function(isEnrolled, activeStatuses) {
    var _activeStatuses = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(activeStatuses, 5), isAboutSectionActive = _activeStatuses[0], isScheduleSectionActive = _activeStatuses[1], isLessonSectionActive = _activeStatuses[2], isEducatorSectionActive = _activeStatuses[3], isFAQsSectionActive = _activeStatuses[4];
    if (isEnrolled) {
        var ref;
        ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(activeStatuses, 5), isScheduleSectionActive = ref[0], isLessonSectionActive = ref[1], isEducatorSectionActive = ref[2], isAboutSectionActive = ref[3], isFAQsSectionActive = ref[4], ref;
    }
    return {
        isAboutSectionActive: isAboutSectionActive,
        isScheduleSectionActive: isScheduleSectionActive,
        isLessonSectionActive: isLessonSectionActive,
        isEducatorSectionActive: isEducatorSectionActive,
        isFAQsSectionActive: isFAQsSectionActive
    };
};



/***/ }),

/***/ 77003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Course_ItemCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(52420);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Container/Banner/RenewalBanner.jsx
var RenewalBanner = __webpack_require__(96794);
// EXTERNAL MODULE: ./src/components/Base/P2/P2.jsx
var P2 = __webpack_require__(72560);
// EXTERNAL MODULE: ./src/components/Base/H6/H6.jsx
var H6 = __webpack_require__(10076);
// EXTERNAL MODULE: ./src/components/Base/Link/Link.jsx
var Link = __webpack_require__(76356);
// EXTERNAL MODULE: ./src/components/Base/H7/H7.jsx
var H7 = __webpack_require__(28197);
// EXTERNAL MODULE: ./src/components/Base/Tags/Tags.jsx
var Tags = __webpack_require__(52236);
// EXTERNAL MODULE: ./src/stores/AppCommonData.jsx + 1 modules
var AppCommonData = __webpack_require__(83995);
// EXTERNAL MODULE: ./src/models/Item.js
var Item = __webpack_require__(46571);
// EXTERNAL MODULE: ./src/components/Icons/MoreVert.jsx
var MoreVert = __webpack_require__(1218);
// EXTERNAL MODULE: ./src/components/Icons/Pdf.jsx
var Pdf = __webpack_require__(68603);
// EXTERNAL MODULE: ./src/components/Icons/Icon.jsx
var Icon = __webpack_require__(55447);
;// CONCATENATED MODULE: ./src/components/Icons/Pin.jsx




var Pin_Pdf = function(props) {
    var color = props.color;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Icon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 -2 18 18",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M4.77205 10.1772L2.94175 12.2408C2.92402 12.2629 2.90466 12.2836 2.88385 12.3027C2.47069 12.6831 1.84963 12.273 2.03722 11.7437C2.04667 11.717 2.05812 11.6911 2.07148 11.6661L3.21094 9.14636",
                stroke: color,
                fill: "none"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M4.08112 5.07351C3.9462 5.21411 3.74206 5.25684 3.5503 5.22222C2.89585 5.10404 2.19299 5.31893 1.68918 5.83055L1.41433 6.10985C1.15149 6.3767 1.01975 6.74523 1.05699 7.10946C1.09423 7.4737 1.29633 7.79331 1.60518 7.97636L6.4925 10.8729C6.80135 11.056 7.18275 11.0822 7.52699 10.9441C7.87124 10.8059 8.14021 10.5187 8.25657 10.1651L8.37847 9.79513C8.60038 9.12098 8.46684 8.41307 8.05997 7.89967C7.93619 7.74349 7.87671 7.53803 7.94149 7.34957L8.54007 5.60814C8.62101 5.37187 8.86215 5.22771 9.16528 5.23437L10.2949 5.2598C10.6441 5.26758 10.9057 5.0758 10.9443 4.78371C10.9828 4.49161 10.7898 4.16474 10.465 3.97223L5.93712 1.2887C5.6123 1.09618 5.22862 1.08123 4.98461 1.25157C4.74059 1.42191 4.691 1.73932 4.86149 2.03957L5.41322 3.01061C5.56113 3.27128 5.54469 3.54861 5.37059 3.72967L4.08112 5.07351Z",
                stroke: color,
                fill: "none"
            })
        ]
    }));
};
Pin_Pdf.propTypes = Icon/* default.proptypes */.Z.proptypes;
Pin_Pdf.defaultProps = Icon/* default.defaultProps */.Z.defaultProps;
/* harmony default export */ var Pin = (Pin_Pdf);

// EXTERNAL MODULE: ./src/components/Icons/Save.jsx
var Save = __webpack_require__(89453);
// EXTERNAL MODULE: ./src/components/Icons/Saved.jsx
var Saved = __webpack_require__(57982);
// EXTERNAL MODULE: ./src/redux/actions/saved.js
var saved = __webpack_require__(9113);
// EXTERNAL MODULE: ./src/redux/actions/analytics.js
var analytics = __webpack_require__(87936);
// EXTERNAL MODULE: ./src/constants/segment.js
var segment = __webpack_require__(17579);
// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(43135);
// EXTERNAL MODULE: ./src/utils/boxShadowGenerator.js
var boxShadowGenerator = __webpack_require__(87312);
// EXTERNAL MODULE: ./src/utils/segment/propsHelper.js
var propsHelper = __webpack_require__(9233);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/hooks/useGoalEventProps.js
var useGoalEventProps = __webpack_require__(52405);
// EXTERNAL MODULE: ./src/stores/snackbar.js
var snackbar = __webpack_require__(97296);
// EXTERNAL MODULE: ./src/events/segmentStorage.js
var segmentStorage = __webpack_require__(71250);
// EXTERNAL MODULE: ./src/redux/selectors/subscription.js
var selectors_subscription = __webpack_require__(83553);
// EXTERNAL MODULE: ./src/models/Batch.js
var Batch = __webpack_require__(47835);
// EXTERNAL MODULE: ./src/components/Educator/Container/AutoDPP/constants.js
var AutoDPP_constants = __webpack_require__(38364);
// EXTERNAL MODULE: ./src/utils/constants.js
var utils_constants = __webpack_require__(47426);
// EXTERNAL MODULE: ./src/components/Container/BatchGroup/utils.js
var utils = __webpack_require__(65840);
// EXTERNAL MODULE: ./src/components/Container/BatchGroup/constants/index.js
var BatchGroup_constants = __webpack_require__(10736);
// EXTERNAL MODULE: ./src/components/Container/Syllabus/TopicPage/chapterInfo/RecordedVideoBlockDialog.tsx
var RecordedVideoBlockDialog = __webpack_require__(67753);
// EXTERNAL MODULE: ./src/hooks/useIsRecordedGoal.js
var useIsRecordedGoal = __webpack_require__(23207);
// EXTERNAL MODULE: ./src/api/hooks/auth/useMyInfo.js
var useMyInfo = __webpack_require__(85780);
// EXTERNAL MODULE: ./src/api/selectors/auth.js
var auth = __webpack_require__(73060);
// EXTERNAL MODULE: ./src/api/hooks/useConstants.js
var useConstants = __webpack_require__(79917);
// EXTERNAL MODULE: ./src/api/selectors/constants.js
var selectors_constants = __webpack_require__(17064);
// EXTERNAL MODULE: ./src/components/Container/Course/LeftIcon.jsx + 1 modules
var LeftIcon = __webpack_require__(98901);
// EXTERNAL MODULE: ./src/components/Base/Button/Button.jsx
var Button = __webpack_require__(35415);
// EXTERNAL MODULE: ./src/utils/pushRoute.js
var pushRoute = __webpack_require__(751);
;// CONCATENATED MODULE: ./src/components/Container/Course/ExtendSubscription.jsx










var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e793ro40",
    label: "Wrapper"
})("grid-column:9/25;padding:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";padding-right:", styleConstants/* Spacings.SPACING_12B */.t8.SL, ";background-color:var(--color-base-1);border-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";margin-bottom:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";box-shadow:", (0,boxShadowGenerator/* default */.Z)(), ";display:flex;justify-content:space-between;@media (max-width:47.95em){flex-wrap:wrap;padding:16px;}");
var Cover = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e793ro41",
    label: "Cover"
})("display:flex;@media (max-width:47.95em){margin-bottom:16px;}");
var Info = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e793ro42",
    label: "Info"
})("width:464px;@media (max-width:47.95em){width:100%;flex:1;}");
var StyledButton = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Button/* default */.Z, {
    target: "e793ro43",
    label: "StyledButton"
})("@media (max-width:47.95em){flex:1;}");
var Copy = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P2/* default */.Z, {
    target: "e793ro44",
    label: "Copy"
})("margin-top:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";");
var ExtendSubscription = function(param) {
    var subscription = param.subscription, className = param.className;
    var ref, ref1, ref2;
    var handleClick = function() {
        var ref, ref1;
        var relativeLink = subscription === null || subscription === void 0 ? void 0 : (ref = subscription.subscription) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.relative_link;
        if (relativeLink) (0,pushRoute/* default */.Z)("/goal/[goalSlug]/[goalUID]/subscribe", "".concat(relativeLink, "/subscribe"));
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Cover, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LeftIcon/* default */.Z, {
                        lesson: {
                            liveAt: subscription.expired_at
                        },
                        showDate: true
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Info, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H6/* default */.Z, {
                                color: "var(--color-text-primary)",
                                children: "Your ".concat((subscription === null || subscription === void 0 ? void 0 : (ref = subscription.subscription) === null || ref === void 0 ? void 0 : ref.type) === 1 ? "subscription" : "free trial", " ends on this day")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Copy, {
                                color: "var(--color-text-secondary)",
                                children: "".concat((subscription === null || subscription === void 0 ? void 0 : (ref1 = subscription.subscription) === null || ref1 === void 0 ? void 0 : ref1.type) === 1 ? "Renew" : "Buy", " your subscription to access sessions after this date")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButton, {
                label: (subscription === null || subscription === void 0 ? void 0 : (ref2 = subscription.subscription) === null || ref2 === void 0 ? void 0 : ref2.type) === 1 ? "Renew" : "Buy",
                grid: 2,
                onClick: handleClick
            })
        ]
    });
};
/* harmony default export */ var Course_ExtendSubscription = (ExtendSubscription);
ExtendSubscription.propTypes = {
    subscription: prop_types_default().objectOf((prop_types_default()).any),
    className: (prop_types_default()).string
};
ExtendSubscription.defaultProps = {
    subscription: null,
    className: ""
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/redux/actions/practiceSession.js
var practiceSession = __webpack_require__(70261);
// EXTERNAL MODULE: ./src/components/Container/Practice/constants.js
var Practice_constants = __webpack_require__(88322);
// EXTERNAL MODULE: ./src/components/Container/Practice/usePracticeSegmentAnalytics.js
var usePracticeSegmentAnalytics = __webpack_require__(30341);
// EXTERNAL MODULE: ./src/stores/auto-dpp/dppFinishSummaryStore.js
var dppFinishSummaryStore = __webpack_require__(77729);
// EXTERNAL MODULE: ./src/stores/planner/practiceStore.js
var practiceStore = __webpack_require__(20647);
// EXTERNAL MODULE: ./src/utils/isEmptyObject.js
var isEmptyObject = __webpack_require__(9759);
;// CONCATENATED MODULE: ./src/components/Container/Course/AutoDpp.jsx
















var AutoDppWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "epnigha0",
    label: "AutoDppWrapper"
})("display:flex;justify-content:space-between;align-items:center;height:", styleConstants/* Spacings.SPACING_14B */.t8.zJ, ";border-top:solid 1px;border-top-color:var(--color-divider);padding-top:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";margin-top:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";");
var AutoDpp_StyledButton = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Button/* default */.Z, {
    target: "epnigha1",
    label: "StyledButton"
})("border-radius:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";font-size:", styleConstants/* Fonts.SMALL */.F3.HC, ";height:40px;");
var DppTextWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "epnigha2",
    label: "DppTextWrapper"
})("display:flex;flex-direction:column;");
var PracticeInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "epnigha3",
    label: "PracticeInfo"
})("margin-top:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";color:var(--color-text-secondary);");
var Title = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P2/* default */.Z, {
    target: "epnigha4",
    label: "Title"
})("font-weight:", styleConstants/* Fonts.SEMIBOLD */.F3.rX, ";line-height:18px;");
var COMPLETED_STATUS = 1;
var IN_COMPLETE_STATUS = 0;
var AutoDpp = function(param) {
    var lesson = param.lesson;
    var goalUid = lesson.goalUid;
    var ref = lesson === null || lesson === void 0 ? void 0 : lesson.practiceDpp, topicGroupUid = ref.topicGroupUid, goalSlug = ref.goalSlug;
    var _author = lesson.author, firstName = _author.firstName, lastName = _author.lastName;
    var ref1 = lesson === null || lesson === void 0 ? void 0 : lesson.liveClassDetails, _practiceDpp = ref1.practiceDpp, practiceDpp = _practiceDpp === void 0 ? {} : _practiceDpp;
    var segmentAnalytics = (0,usePracticeSegmentAnalytics/* default */.Z)(goalUid);
    var ref2 = (0,dppFinishSummaryStore/* default */.Z)(), toggleShowSummary = ref2.toggleShowSummary, setFinishSummary = ref2.setFinishSummary;
    var finishPlannerPracticeSession = (0,practiceStore/* default */.Z)().finishPlannerPracticeSession;
    var dispatch = (0,es/* useDispatch */.I0)();
    if ((0,isEmptyObject/* default */.Z)(practiceDpp)) {
        return null;
    }
    var status = practiceDpp.status, sessionUid = practiceDpp.sessionUid, _solvedQuestions = practiceDpp.solvedQuestions, solvedQuestions = _solvedQuestions === void 0 ? 0 : _solvedQuestions, _numQuestions = practiceDpp.numQuestions, numQuestions = _numQuestions === void 0 ? 0 : _numQuestions, quizUID = practiceDpp.uid;
    var isCompleted = status === COMPLETED_STATUS;
    var isInComplete = status === IN_COMPLETE_STATUS;
    var handleButtonClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event.preventDefault();
                        event.stopPropagation();
                        if (!(isCompleted && sessionUid)) {
                            _ctx.next = 8;
                            break;
                        }
                        finishPlannerPracticeSession({}, false);
                        _ctx.next = 6;
                        return dispatch((0,practiceSession/* finishPracticeSession */.GF)(sessionUid));
                    case 6:
                        setFinishSummary({
                            goalSlug: goalSlug,
                            goalUID: goalUid,
                            sessionId: sessionUid,
                            topicGroup: topicGroupUid,
                            topicUID: topicGroupUid,
                            quizUID: quizUID,
                            type: Practice_constants/* PRACTICE_FLOW_TYPE.AUTO_DPP */.nI.AUTO_DPP,
                            educatorName: "".concat(firstName, " ").concat(lastName)
                        });
                        return _ctx.abrupt("return", toggleShowSummary());
                    case 8:
                        if (!(quizUID && topicGroupUid && goalUid && goalSlug)) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", (0,pushRoute/* default */.Z)({
                            pathname: "/goal/[goalSlug]/[goalUID]/practice/[topicUID]",
                            query: {
                                goalSlug: goalSlug,
                                goalUID: goalUid,
                                topic_type: Practice_constants/* PRACTICE_TYPE.EACH_TOPIC */.Ws.EACH_TOPIC,
                                type: Practice_constants/* PRACTICE_FLOW_TYPE.AUTO_DPP */.nI.AUTO_DPP,
                                topic_group: topicGroupUid,
                                topicUID: topicGroupUid,
                                quiz_uid: quizUID,
                                educator_name: "".concat(firstName, " ").concat(lastName),
                                source: "Course"
                            }
                        }).then(function() {
                            return segmentAnalytics(segment/* PRACTICE_STARTED */.k6n, {
                                topic_uid: null,
                                practice_questions: numQuestions,
                                topology_id: topicGroupUid,
                                topology_name: "NA",
                                topology_level: "NA",
                                last_primary_source: "Course",
                                language: "NA",
                                practice_type: "Educator Led Practice",
                                is_completed: isCompleted ? "Yes" : "No"
                            });
                        }));
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleButtonClick(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var getInfoString = function() {
        if (isCompleted) {
            return "Completed";
        }
        if (isInComplete && sessionUid && solvedQuestions >= 1) {
            return "".concat(numQuestions - solvedQuestions, " of ").concat(numQuestions, " questions remaining");
        }
        return "".concat(numQuestions, " questions");
    };
    var getBtnVariant = function() {
        if (isCompleted) {
            return "View practice";
        }
        if (isInComplete && sessionUid && solvedQuestions >= 1) {
            return "Resume practice";
        }
        return "Start practice";
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AutoDppWrapper, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DppTextWrapper, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                            color: "var(--color-text-primary)",
                            children: "Practice"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PracticeInfo, {
                            children: getInfoString()
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AutoDpp_StyledButton, {
                    variant: "hollow",
                    color: "black",
                    label: getBtnVariant(),
                    width: "141px",
                    maxHeight: "sm",
                    onClick: handleButtonClick
                })
            ]
        })
    });
};
/* harmony default export */ var Course_AutoDpp = (AutoDpp);

;// CONCATENATED MODULE: ./src/components/Container/Course/ItemCard.jsx



/* eslint-disable max-lines */ /* eslint-disable react/prop-types */ 










































var fontLightGreyColor = "var(--color-text-secondary)";
var CourseInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P2/* default */.Z, {
    target: "ecq12m80",
    label: "CourseInfo"
})("margin-top:", function(param) {
    var $isRecordedBatchLesson = param.$isRecordedBatchLesson;
    return $isRecordedBatchLesson ? styleConstants/* Spacings.SPACING_0B */.t8.NE : styleConstants/* Spacings.SPACING_2B */.t8.Rw;
}, ";@media only screen and (max-width:47.95em){font-size:12px;margin-top:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";}");
var NotesPinContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(CourseInfo, {
    target: "ecq12m81",
    label: "NotesPinContainer"
})("display:flex;");
var ItemInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ecq12m82",
    label: "ItemInfo"
})("width:464px;flex:1;@media only screen and (max-width:47.95em){width:auto;& > h6{font-size:14px;}}");
var MenuButton = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ecq12m83",
    label: "MenuButton"
})("display:flex;height:24px;margin-left:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";position:relative;");
var Flex = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ecq12m84",
    label: "Flex"
})("display:flex;margin-top:", function(param) {
    var $isRecordedBatchLesson = param.$isRecordedBatchLesson;
    return $isRecordedBatchLesson ? styleConstants/* Spacings.SPACING_0B */.t8.NE : styleConstants/* Spacings.SPACING_2B */.t8.Rw;
}, ";margin-bottom:", function(param) {
    var $isRecordedBatchLesson = param.$isRecordedBatchLesson;
    return $isRecordedBatchLesson ? styleConstants/* Spacings.SPACING_1B */.t8.MK : styleConstants/* Spacings.SPACING_0B */.t8.NE;
}, ";align-items:center;flex-flow:wrap;row-gap:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";");
var TopicGroupWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ecq12m85",
    label: "TopicGroupWrapper"
})("display:flex;flex-direction:row;align-items:center;");
var Color = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ecq12m86",
    label: "Color"
})("height:12px;width:4px;background-color:", function(param) {
    var color = param.color;
    return color;
}, ";margin-right:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";border-radius:2px;");
var TopicGroupName = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H7/* default */.Z, {
    target: "ecq12m87",
    label: "TopicGroupName"
})("margin-right:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";font-weight:", function(param) {
    var $isRecordedBatchLesson = param.$isRecordedBatchLesson;
    return $isRecordedBatchLesson ? styleConstants/* Fonts.HEAVY */.F3.XR : "";
}, ";", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{font-size:", styleConstants/* Fonts.EXTRA_SMALL */.F3.y2, ";}");
var Renew = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(RenewalBanner/* default */.Z, {
    target: "ecq12m88",
    label: "Renew"
})("margin-bottom:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";margin-top:0px;");
var Tooltip = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Tags/* default */.Z, {
    target: "ecq12m89",
    label: "Tooltip"
})("font-size:10px;color:var(--color-text-primary);padding:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";border:1px solid var(--color-divider);position:absolute;white-space:nowrap;left:-6px;top:calc(100% + 8px);");
var ItemContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ecq12m810",
    label: "ItemContainer"
})("padding:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";background-color:var(--color-base-1);border-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";margin-bottom:", function(param) {
    var $isRecordedBatchLesson = param.$isRecordedBatchLesson;
    return $isRecordedBatchLesson ? styleConstants/* Spacings.SPACING_8B */.t8.B3 : styleConstants/* Spacings.SPACING_6B */.t8.BY;
}, ";box-shadow:", (0,boxShadowGenerator/* default */.Z)(), ";display:flex;:hover{box-shadow:", (0,boxShadowGenerator/* default */.Z)({
    yOffset: styleConstants/* Spacings.SPACING_1B */.t8.MK,
    blur: styleConstants/* Spacings.SPACING_2B */.t8.Rw
}), ";}transition:box-shadow 0.2s ease-in-out;@media (max-width:47.95em){width:100%;padding:12px 16px;margin-bottom:16px;}");
var FlexContent = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ecq12m811",
    label: "FlexContent"
})("display:flex;flex-direction:column;width:100%;");
var LessonWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ecq12m812",
    label: "LessonWrapper"
})("display:flex;width:100%;align-items:center;");
var CourseInfoContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ecq12m813",
    label: "CourseInfoContainer"
})("margin-top:", function(param) {
    var $isRecordedBatchLesson = param.$isRecordedBatchLesson;
    return $isRecordedBatchLesson ? styleConstants/* Spacings.SPACING_1B */.t8.MK : styleConstants/* Spacings.SPACING_0B */.t8.NE;
}, ";display:flex;justify-content:flex-start;align-items:flex-end;");
var ClassBatchLive = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ecq12m814",
    label: "ClassBatchLive"
})("padding:", styleConstants/* Spacings.SPACING_2 */.t8.Jl, " ", styleConstants/* Spacings.SPACING_6 */.t8.A1, ";background:var(--color-i-red);border-radius:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";font-size:", styleConstants/* Fonts.EXTRA_SMALL */.F3.y2, ";color:var(--color-i-white);font-weight:", styleConstants/* Fonts.HEAVY */.F3.XR, ";margin-right:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";line-height:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";text-transform:uppercase;display:flex;justify-content:center;align-items:center;");
var LessonName = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H6/* default */.Z, {
    target: "ecq12m815",
    label: "LessonName"
})("text-decoration:", function(param) {
    var _$isTextStrikeout = param.$isTextStrikeout, $isTextStrikeout = _$isTextStrikeout === void 0 ? false : _$isTextStrikeout;
    return $isTextStrikeout ? "line-through" : "unset";
}, ";color:", function(param) {
    var _$isTextStrikeout = param.$isTextStrikeout, $isTextStrikeout = _$isTextStrikeout === void 0 ? false : _$isTextStrikeout;
    return $isTextStrikeout ? "var(--color-text-secondary)" : "var(--color-text-primary)";
}, ";font-size:", function(param) {
    var $isRecordedBatchLesson = param.$isRecordedBatchLesson;
    return $isRecordedBatchLesson ? "16px" : "";
}, ";", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{font-size:", function(param) {
    var $isRecordedBatchLesson = param.$isRecordedBatchLesson;
    return $isRecordedBatchLesson ? styleConstants/* Fonts.H6 */.F3.H6 : "";
}, ";}");
var ItemCard_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ecq12m816",
    label: "Wrapper"
})("grid-column:9/25;cursor:pointer;", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{display:block;grid-column:span 10;}");
var isQuizPage = function(href) {
    var isBatchPage = [
        "/batch/[slug]/[batchUID]/topics/[topicUID]/courses/[conceptUID]",
        "/batch/[slug]/[batchUID]/topics/[topicUID]/courses/[conceptUID]/course/[courseUID]",
        "/batch/[slug]/[batchUID]/schedule"
    ].includes(href);
    var isCoursePage = [
        "/course/[slug]/[courseUID]"
    ].includes(href);
    return isBatchPage || isCoursePage;
};
var isTestSeriesPage = function(href) {
    return href === "/test-series/[slug]/[courseUID]";
};
var renderNotes = function(showNotesCount) {
    var notesCount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (showNotesCount) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NotesPinContainer, {
            color: fontLightGreyColor,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pin, {
                    size: "18px",
                    color: fontLightGreyColor
                }),
                notesCount,
                " notes"
            ]
        });
    }
    return null;
};
var renderPrimaryTopicGroup = function(showPrimaryTopicGroup) {
    var topicGroups = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if (showPrimaryTopicGroup && topicGroups.length > 0) {
        var primaryTopicGroup = topicGroups.find(function(currentTopicGroup) {
            return currentTopicGroup.level === constants/* topologyLevels.GROUP */.OP.GROUP;
        });
        if (primaryTopicGroup) {
            return "".concat(primaryTopicGroup.title, "  \u2022  ");
        }
    }
    return null;
};
var LiveClassBatch = function(param) {
    var lesson = param.lesson;
    var classState = lesson === null || lesson === void 0 ? void 0 : lesson.classState;
    if (classState === BatchGroup_constants/* CLASS_STATE.LIVE_STATE */.gy.LIVE_STATE) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClassBatchLive, {
            children: "Live"
        });
    }
    return null;
};
var ItemCard = function(param) {
    var lesson = param.lesson, onItemClick = param.onItemClick, showEducatorForLesson = param.showEducatorForLesson, showLessonNumber = param.showLessonNumber, showQuizNumber = param.showQuizNumber, showNotesCount = param.showNotesCount, showTopicGroups = param.showTopicGroups, showPrimaryTopicGroup = param.showPrimaryTopicGroup, isTestSeries = param.isTestSeries, forPlus = param.forPlus, cardPosition = param.cardPosition, subscription = param.subscription, setAnchorEl = param.setAnchorEl, setPdfAnchorEl = param.setPdfAnchorEl, isSubscribed = param.isSubscribed, isBatch = param.isBatch, showMoreMenu = param.showMoreMenu, renewalData = param.renewalData, className = param.className, showBookmark = param.showBookmark, showRemoveDialog = param.showRemoveDialog, goalUID = param.goalUID, isBatchGroup = param.isBatchGroup, showLiveBatch = param.showLiveBatch, hasDppAccess = param.hasDppAccess, isRecordedBatchLesson = param.isRecordedBatchLesson, isOnlyRecordedClassesPresent = param.isOnlyRecordedClassesPresent, label = param.label;
    var ref;
    var isMobile = (0,AppCommonData/* useIsMobile */.dD)();
    var route = (0,router.useRouter)().route;
    var anchorStyle = "\n  grid-column: 9/25;\n  ".concat(styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, " {\n    display: block;\n    grid-column: span 10;\n  }\n");
    var isLoggedIn = (0,useMyInfo/* default */.Z)(auth/* getIsLoggedIn */.M7);
    var retrievedGoalUID = goalUID || ((ref = lesson.goal) === null || ref === void 0 ? void 0 : ref.uid) || lesson.goalUid;
    var goalSegmentData = (0,useGoalEventProps/* default */.Z)({
        goalUID: retrievedGoalUID
    });
    var isLiteUser = (0,es/* useSelector */.v9)((0,selectors_subscription/* getIsSubscribedToLite */.aA)(retrievedGoalUID));
    var dispatch = (0,es/* useDispatch */.I0)();
    var isNeoLesson = lesson.classType === utils_constants/* NEOLESSON */.K_;
    var classState = lesson === null || lesson === void 0 ? void 0 : lesson.classState;
    var isClassCancelled = classState === BatchGroup_constants/* CLASS_STATE.CANCELLED_STATE */.gy.CANCELLED_STATE;
    var ref1 = (0,snackbar/* useSnackbar */.Ds)(), showSnackbar = ref1.open;
    var isRecordedGoal = (0,useIsRecordedGoal/* default */.Z)(retrievedGoalUID);
    var ref2 = (0,react.useState)(false), showRecordedGoalDialog = ref2[0], setShowRecordedGoalDialog = ref2[1];
    var isRecordedContentPlayAllowed = (0,useConstants/* default */.Z)((0,selectors_constants/* getIsRCPlayAllowed */.dk)(retrievedGoalUID));
    var handleCloseRecordedVideoDialog = function() {
        setShowRecordedGoalDialog(false);
    };
    var onLessonClick = function(e) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        segmentStorage/* default.setItem */.Z.setItem("lps", "test-series");
        var as = (0,Item/* getItemRedirectURL */.Ti)(lesson, forPlus).as;
        if (isRecordedGoal && !isRecordedContentPlayAllowed && lesson.type !== "quiz" && !(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.closest(".slides")) && !((e === null || e === void 0 ? void 0 : (ref1 = e.target) === null || ref1 === void 0 ? void 0 : ref1.closest(".menuButton")) || (e === null || e === void 0 ? void 0 : (ref2 = e.target) === null || ref2 === void 0 ? void 0 : ref2.closest(".MuiPopover-root")))) {
            e.preventDefault();
            setShowRecordedGoalDialog(true);
            return;
        }
        /**
     * preventDefault was somehow blocking the redirection of lesson (CLX interface) on test series page.
     */ if (!isTestSeries) e.preventDefault();
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        if (e === null || e === void 0 ? void 0 : (ref3 = e.target) === null || ref3 === void 0 ? void 0 : ref3.closest(".slides")) {
            setAnchorEl(null);
            return;
        }
        if ((e === null || e === void 0 ? void 0 : (ref4 = e.target) === null || ref4 === void 0 ? void 0 : ref4.closest(".menuButton")) || (e === null || e === void 0 ? void 0 : (ref5 = e.target) === null || ref5 === void 0 ? void 0 : ref5.closest(".MuiPopover-root"))) return;
        if (e.ctrlKey || e.metaKey) {
            window.open(as, "_blank");
            return;
        }
        if (!isMobile || lesson.type === "post" && !forPlus) {
            // Adding LPSS to segment from label property and deleting it on class exit
            // in case property is not deleted removing it if label is not passed
            if (label) segmentStorage/* default.setItem */.Z.setItem("lpss", label);
            else segmentStorage/* default.deleteItem */.Z.deleteItem("lpss");
            onItemClick(lesson);
        }
    };
    var handleMenuClick = function(event) {
        event.preventDefault();
        setAnchorEl(event.currentTarget, lesson);
    };
    var handlePdfClick = function(event) {
        setPdfAnchorEl(event.currentTarget, lesson);
    };
    var handleNeoLessonPdfClick = function() {
        var ref, ref1, ref2;
        analytics/* segment.track */.EX.track(segment/* PDF_DOWNLOAD */.siE, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, goalSegmentData), {
            download_type: "With annotations",
            lesson_type: "Recorded",
            is_annotation_on: true,
            last_primary_source: segmentStorage/* default.getItem */.Z.getItem("lps"),
            lesson_uid: lesson.uid,
            lesson_title: lesson.name,
            educator_uid: (ref = lesson.author) === null || ref === void 0 ? void 0 : ref.uid,
            educator_username: (ref1 = lesson.author) === null || ref1 === void 0 ? void 0 : ref1.name
        }));
        window.open((ref2 = lesson.slides) === null || ref2 === void 0 ? void 0 : ref2.withAnnotations);
    };
    var renderTopicGroups = function() {
        var topicGroupTextColor = isClassCancelled ? "var(--color-text-secondary)" : "var(--color-text-primary)";
        var showTags = isMobile ? 1 : 3;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Flex, {
            $isRecordedBatchLesson: isRecordedBatchLesson,
            children: lesson.topicGroups.slice(0, showTags).map(function(topicGroup) {
                var tagColor = isClassCancelled ? "var(--color-text-secondary)" : topicGroup.color;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TopicGroupWrapper, {
                    children: [
                        !isRecordedBatchLesson && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Color, {
                            color: tagColor
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopicGroupName, {
                            color: isRecordedBatchLesson ? topicGroup.color : topicGroupTextColor,
                            as: "h5",
                            $isRecordedBatchLesson: isRecordedBatchLesson,
                            children: isRecordedBatchLesson ? topicGroup.name.toUpperCase() : topicGroup.name
                        }, "".concat(lesson.uid, "_").concat(topicGroup.uid))
                    ]
                }, topicGroup.uid);
            })
        });
    };
    var renderExtendCard = function() {
        if (renewalData === null || renewalData === void 0 ? void 0 : renewalData.show) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Renew, {
            data: renewalData,
            subscription: subscription,
            gridColumn: "9/25",
            lastPrimarySource: "Course Page"
        });
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Course_ExtendSubscription, {
            subscription: subscription
        });
    };
    var ref3 = (0,Item/* getItemRedirectURL */.Ti)(lesson, forPlus), as = ref3.as, href = ref3.href;
    var isItemCompletedWithNoVideoUrl = (0,Item/* isCompletedWithNoVideoUrl */.gZ)(lesson);
    var hideUploadedDate = isOnlyRecordedClassesPresent || isNeoLesson;
    var infoString = isBatchGroup ? (0,utils/* getInfoStringForBatchGroup */.ec)(lesson) : (0,Item/* getInfoString */.k$)(lesson, isTestSeries, forPlus, isBatch, false, showLessonNumber, showQuizNumber, 1, isRecordedBatchLesson, hideUploadedDate);
    var strForLoggedInUser = isItemCompletedWithNoVideoUrl && !isLiteUser ? "Lesson recording will be available soon" : infoString;
    var displayInfoString = !isSubscribed ? infoString : strForLoggedInUser;
    var addToCollection = function() {
        var ref;
        var isItemPost = (0,Item/* isPost */.f5)(lesson);
        var entityType = isItemPost ? constants/* savedObjectTypes.LESSON */.cc.LESSON : constants/* savedObjectTypes.TEST */.cc.TEST;
        dispatch((0,saved/* saveEntity */.FU)({
            goalUid: goalUID || ((ref = lesson.goal) === null || ref === void 0 ? void 0 : ref.uid) || lesson.goalUid,
            objectUid: lesson.uid,
            entityType: entityType
        })).then(function() {
            showSnackbar({
                message: "Saved to ".concat(isItemPost ? "Lessons" : "Tests"),
                type: "success"
            });
            analytics/* segment.track */.EX.track(segment/* SAVE_SAVE_CONTENT */.LNG, (0,_object_spread/* default */.Z)({
                save_content_type: (0,propsHelper/* getSavedContentType */.D)(entityType),
                save_content_uid: lesson.uid,
                save_content_title: lesson.name
            }, goalSegmentData));
        });
    };
    var isSaved = (0,es/* useSelector */.v9)(function(param) {
        var items = param.items;
        var ref, ref1, ref2, ref3;
        return ((ref = items.data) === null || ref === void 0 ? void 0 : (ref1 = ref[lesson.uid]) === null || ref1 === void 0 ? void 0 : ref1.isSaved) !== undefined ? (ref2 = items.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[lesson.uid]) === null || ref3 === void 0 ? void 0 : ref3.isSaved : lesson.isSaved;
    });
    var isQuiz = (lesson === null || lesson === void 0 ? void 0 : lesson.type) === "quiz" && isQuizPage(route);
    var isLessonInTestSeries = (lesson === null || lesson === void 0 ? void 0 : lesson.type) === "post" && isTestSeriesPage(route);
    var enableBookmark = !isQuiz && !isLessonInTestSeries && !(0,Item/* isLessonLive */.NJ)(lesson) && isSubscribed && showBookmark && !(0,Item/* isUpcoming */.Zz)(lesson) && !(0,Item/* classDidNotHappen */.cl)(lesson) && !isItemCompletedWithNoVideoUrl;
    var ref4 = (0,react.useState)(false), showTooltip = ref4[0], setShowTooltip = ref4[1];
    var onSaveClick = function(event) {
        event.preventDefault();
        event.stopPropagation();
        if (isSaved) {
            showRemoveDialog(lesson);
        } else {
            addToCollection();
        }
        setShowTooltip(false);
    };
    var renderItem = function() {
        var ref, ref1;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemContainer, {
            className: "itemContainer",
            isRecordedBatchLesson: isRecordedBatchLesson,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LeftIcon/* default */.Z, {
                    isBatchGroup: isBatchGroup,
                    lesson: lesson,
                    isRecordedBatchLesson: isRecordedBatchLesson
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FlexContent, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LessonWrapper, {
                            className: "lessonWrapper",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemInfo, {
                                    id: lesson.uid,
                                    children: [
                                        isRecordedBatchLesson && showTopicGroups && isBatch && (0,Item/* isPost */.f5)(lesson) && renderTopicGroups(),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LessonName, {
                                            $isTextStrikeout: isClassCancelled,
                                            color: "var(--color-text-primary)",
                                            as: "h3",
                                            $isRecordedBatchLesson: isRecordedBatchLesson,
                                            children: lesson.name || (lesson === null || lesson === void 0 ? void 0 : (ref = lesson.properties) === null || ref === void 0 ? void 0 : ref.title)
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseInfoContainer, {
                                            $isRecordedBatchLesson: isRecordedBatchLesson,
                                            children: [
                                                showLiveBatch && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LiveClassBatch, {
                                                    lesson: lesson
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CourseInfo, {
                                                    color: "var(--color-text-secondary)",
                                                    $isRecordedBatchLesson: isRecordedBatchLesson,
                                                    children: [
                                                        renderPrimaryTopicGroup(showPrimaryTopicGroup, lesson === null || lesson === void 0 ? void 0 : lesson.topicGroups),
                                                        displayInfoString,
                                                        showEducatorForLesson && "  \u2022  ".concat((0,Batch/* getAuthorName */.uM)((lesson === null || lesson === void 0 ? void 0 : lesson.author) || {}))
                                                    ]
                                                })
                                            ]
                                        }),
                                        renderNotes(showNotesCount, lesson === null || lesson === void 0 ? void 0 : lesson.notesCount),
                                        !isRecordedBatchLesson && showTopicGroups && isBatch && renderTopicGroups()
                                    ]
                                }),
                                !(0,Item/* classDidNotHappen */.cl)(lesson) && (lesson.slides || lesson.slidesPdf) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuButton, {
                                    onClick: isNeoLesson ? handleNeoLessonPdfClick : handlePdfClick,
                                    className: "menuButton",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pdf/* default */.Z, {
                                        size: "24px",
                                        color: "var(--color-text-primary)"
                                    })
                                }),
                                enableBookmark && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MenuButton, {
                                    onClick: onSaveClick,
                                    onMouseOver: isSaved ? undefined : function() {
                                        return setShowTooltip(true);
                                    },
                                    onMouseOut: isSaved ? undefined : function() {
                                        return setShowTooltip(false);
                                    },
                                    children: [
                                        isSaved ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Saved/* default */.Z, {
                                            size: styleConstants/* Spacings.SPACING_6B */.t8.BY,
                                            color: "var(--color-i-green)"
                                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Save/* default */.Z, {
                                            size: styleConstants/* Spacings.SPACING_6B */.t8.BY,
                                            color: "var(--color-text-primary)"
                                        }),
                                        showTooltip && !isSaved && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip, {
                                            children: "Save"
                                        })
                                    ]
                                }),
                                showMoreMenu && !isRecordedBatchLesson && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuButton, {
                                    onClick: handleMenuClick,
                                    className: "menuButton",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoreVert/* default */.Z, {
                                        size: "24px",
                                        color: "var(--color-text-primary)"
                                    })
                                })
                            ]
                        }),
                        (!isBatch || isRecordedBatchLesson) && (isSubscribed || hasDppAccess) && (lesson === null || lesson === void 0 ? void 0 : (ref1 = lesson.practiceDpp) === null || ref1 === void 0 ? void 0 : ref1.state) === AutoDPP_constants/* DPP_STATE.PUBLISHED */.ST.PUBLISHED && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Course_AutoDpp, {
                            lesson: lesson
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            isLoggedIn ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                href: href,
                as: as,
                anchorStyle: anchorStyle,
                className: className,
                onClick: onLessonClick,
                children: renderItem()
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemCard_Wrapper, {
                onClick: onLessonClick,
                className: className,
                children: renderItem()
            }),
            cardPosition === lesson.rank && renderExtendCard(),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecordedVideoBlockDialog/* default */.Z, {
                isOpen: showRecordedGoalDialog,
                onClose: handleCloseRecordedVideoDialog
            })
        ]
    });
};
/* harmony default export */ var Course_ItemCard = (ItemCard);
ItemCard.propTypes = {
    lesson: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    onItemClick: (prop_types_default()).func.isRequired,
    showEducatorForLesson: (prop_types_default()).bool.isRequired,
    showNotesCount: (prop_types_default()).bool,
    showLessonNumber: (prop_types_default()).bool,
    showTopicGroups: (prop_types_default()).bool,
    showPrimaryTopicGroup: (prop_types_default()).bool,
    showQuizNumber: (prop_types_default()).bool,
    isTestSeries: (prop_types_default()).bool,
    forPlus: (prop_types_default()).bool.isRequired,
    cardPosition: (prop_types_default()).number.isRequired,
    subscription: prop_types_default().objectOf((prop_types_default()).any),
    setAnchorEl: (prop_types_default()).func.isRequired,
    setPdfAnchorEl: (prop_types_default()).func.isRequired,
    isSubscribed: (prop_types_default()).bool,
    isBatch: (prop_types_default()).bool.isRequired,
    showMoreMenu: (prop_types_default()).bool,
    className: (prop_types_default()).string,
    showBookmark: (prop_types_default()).bool,
    showRemoveDialog: (prop_types_default()).func,
    isBatchGroup: (prop_types_default()).bool,
    label: (prop_types_default()).string
};
ItemCard.defaultProps = {
    showLessonNumber: true,
    showQuizNumber: true,
    showNotesCount: false,
    showPrimaryTopicGroup: false,
    showTopicGroups: true,
    isTestSeries: false,
    subscription: null,
    isSubscribed: false,
    className: "",
    showMoreMenu: false,
    showBookmark: true,
    showRemoveDialog: function() {},
    isBatchGroup: false,
    label: ""
};


/***/ }),

/***/ 98901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Course_LeftIcon; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Base/H4/H4.jsx
var H4 = __webpack_require__(64250);
// EXTERNAL MODULE: ./src/components/Base/H7/H7.jsx
var H7 = __webpack_require__(28197);
// EXTERNAL MODULE: ./src/components/Icons/Syllabus/Play.jsx
var Play = __webpack_require__(43853);
// EXTERNAL MODULE: ./src/components/Base/LinearProgressBar/LinearProgressBar.jsx
var LinearProgressBar = __webpack_require__(50699);
// EXTERNAL MODULE: ./src/components/Icons/PlayCircleBig.jsx
var PlayCircleBig = __webpack_require__(26459);
// EXTERNAL MODULE: ./src/components/Icons/CheckBig.jsx
var CheckBig = __webpack_require__(17192);
// EXTERNAL MODULE: ./src/utils/imageHelper.js
var imageHelper = __webpack_require__(48821);
// EXTERNAL MODULE: ./src/utils/dates.js
var dates = __webpack_require__(97428);
// EXTERNAL MODULE: ./src/utils/boxShadowGenerator.js
var boxShadowGenerator = __webpack_require__(87312);
// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(43135);
// EXTERNAL MODULE: ./src/models/Item.js
var Item = __webpack_require__(46571);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/hooks/useEducatorContext.js
var useEducatorContext = __webpack_require__(49465);
// EXTERNAL MODULE: ./src/components/Container/BatchGroup/constants/index.js
var BatchGroup_constants = __webpack_require__(10736);
;// CONCATENATED MODULE: ./src/components/Container/BatchGroup/BatchGroupLeftIcon.jsx











var ShadowPulse = /*#__PURE__*/ (0,emotion_react_browser_esm.keyframes)("0%{box-shadow:", (0,boxShadowGenerator/* default */.Z)({
    yOffset: styleConstants/* Spacings.SPACING_0B */.t8.NE,
    blur: styleConstants/* Spacings.SPACING_0B */.t8.NE,
    color: BatchGroup_constants/* boxShadowColorPercent.0 */.Pk[0]
}), ";}70%{box-shadow:", (0,boxShadowGenerator/* default */.Z)({
    yOffset: styleConstants/* Spacings.SPACING_0B */.t8.NE,
    blur: styleConstants/* Spacings.SPACING_0B */.t8.NE,
    spread: "10px",
    color: BatchGroup_constants/* boxShadowColorPercent.70 */.Pk[70]
}), ";}100%{box-shadow:none;}", "ShadowPulse");
var Month = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H7/* default */.Z, {
    target: "e1cdoev30",
    label: "Month"
})("width:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";text-align:center;text-transform:uppercase;text-decoration:", function(param) {
    var _$isTextStrikeout = param.$isTextStrikeout, $isTextStrikeout = _$isTextStrikeout === void 0 ? false : _$isTextStrikeout;
    return $isTextStrikeout ? "line-through" : "unset";
}, ";color:", function(param) {
    var _$isTextStrikeout = param.$isTextStrikeout, $isTextStrikeout = _$isTextStrikeout === void 0 ? false : _$isTextStrikeout;
    return $isTextStrikeout ? "var(--color-text-secondary)" : "var(--color-text-primary)";
}, ";");
var Day = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H4/* default */.Z, {
    target: "e1cdoev31",
    label: "Day"
})("text-align:center;color:var(--color-text-primary);text-decoration:", function(param) {
    var _$isTextStrikeout = param.$isTextStrikeout, $isTextStrikeout = _$isTextStrikeout === void 0 ? false : _$isTextStrikeout;
    return $isTextStrikeout ? "line-through" : "unset";
}, ";color:", function(param) {
    var _$isTextStrikeout = param.$isTextStrikeout, $isTextStrikeout = _$isTextStrikeout === void 0 ? false : _$isTextStrikeout;
    return $isTextStrikeout ? "var(--color-text-secondary)" : "var(--color-text-primary)";
}, ";", styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{font-size:18px;}");
var Live = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(PlayCircleBig/* default */.Z, {
    target: "e1cdoev32",
    label: "Live"
})("margin-right:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";border-radius:50%;box-shadow:", (0,boxShadowGenerator/* default */.Z)({
    yOffset: styleConstants/* Spacings.SPACING_0B */.t8.NE,
    blur: styleConstants/* Spacings.SPACING_0B */.t8.NE,
    color: BatchGroup_constants/* boxShadowColorPercent.0 */.Pk[0]
}), ";animation:", ShadowPulse, " 2s infinite;:hover{animation:none;}");
var Icon = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("img", {
    target: "e1cdoev33",
    label: "Icon"
})("margin-right:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";height:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";width:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";user-drag:none;user-select:none;");
var BatchGroupLeftIcon_Play = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(PlayCircleBig/* default */.Z, {
    target: "e1cdoev34",
    label: "Play"
})("margin-right:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";");
var BatchGroupLeftIcon = function(param) {
    var lesson = param.lesson;
    var liveAt = lesson.liveAt, startsAt = lesson.startsAt, watchTime = lesson.watchTime, lessonDuration = lesson.lessonDuration;
    var classState = lesson === null || lesson === void 0 ? void 0 : lesson.classState;
    var live = liveAt ? new Date(liveAt) : new Date(startsAt);
    if (classState === BatchGroup_constants/* CLASS_STATE.LIVE_STATE */.gy.LIVE_STATE) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Live, {
            size: "40px",
            color: "var(--color-i-red)"
        });
    }
    if (classState === BatchGroup_constants/* CLASS_STATE.COMPLETELY_WATCHED_STATE */.gy.COMPLETELY_WATCHED_STATE) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
            src: (0,imageHelper/* getImage */.gJ)("batch-group/completed-class.svg"),
            alt: "icon"
        });
    }
    if (classState === BatchGroup_constants/* CLASS_STATE.NOT_WATCHED_STATE */.gy.NOT_WATCHED_STATE) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BatchGroupLeftIcon_Play, {
            size: "40px",
            color: "var(--color-i-green)"
        });
    }
    if (classState === BatchGroup_constants/* CLASS_STATE.CONTINUE_WATCH_STATE */.gy.CONTINUE_WATCH_STATE) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BatchGroupLeftIcon_Play, {
                    size: "40px",
                    color: "var(--color-i-green)"
                }),
                watchTime ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinearProgressBar/* default */.Z, {
                    value: Math.max(watchTime * 100 / lessonDuration, 10),
                    width: "40px",
                    backgroundColor: "var(--color-divider)"
                }) : null
            ]
        });
    }
    if (classState === BatchGroup_constants/* CLASS_STATE.ACCESS_ENDED_STATE */.gy.ACCESS_ENDED_STATE) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
            src: (0,imageHelper/* getImage */.gJ)("batch-group/access-end-play-icon.svg"),
            alt: "icon"
        });
    }
    var isTextStrikeout = classState === BatchGroup_constants/* CLASS_STATE.CANCELLED_STATE */.gy.CANCELLED_STATE || classState === BatchGroup_constants/* CLASS_STATE.RESCHEDULED_STATE */.gy.RESCHEDULED_STATE;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Month, {
                $isTextStrikeout: isTextStrikeout,
                children: live ? live.toLocaleString("default", {
                    month: "short"
                }) : ""
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Day, {
                $isTextStrikeout: isTextStrikeout,
                children: live ? live === null || live === void 0 ? void 0 : live.getDate() : ""
            })
        ]
    });
};
/* harmony default export */ var BatchGroup_BatchGroupLeftIcon = (BatchGroupLeftIcon);

// EXTERNAL MODULE: ./src/components/Educator/Container/CreatePlusCourse/constants.js
var CreatePlusCourse_constants = __webpack_require__(61303);
// EXTERNAL MODULE: ./src/components/Container/Syllabus/constants/getTopicGroupAssetObj.js
var getTopicGroupAssetObj = __webpack_require__(77608);
// EXTERNAL MODULE: ./src/components/Container/Syllabus/TopicPage/chapterInfo/ChapterInfo.tsx + 7 modules
var ChapterInfo = __webpack_require__(19396);
;// CONCATENATED MODULE: ./src/components/Container/Course/LeftIcon.jsx





















var LeftIcon_ShadowPulse = /*#__PURE__*/ (0,emotion_react_browser_esm.keyframes)("0%{box-shadow:", (0,boxShadowGenerator/* default */.Z)({
    yOffset: styleConstants/* Spacings.SPACING_0B */.t8.NE,
    blur: styleConstants/* Spacings.SPACING_0B */.t8.NE,
    color: "rgba(235,87,87, 0.4)"
}), ";}70%{box-shadow:", (0,boxShadowGenerator/* default */.Z)({
    yOffset: styleConstants/* Spacings.SPACING_0B */.t8.NE,
    blur: styleConstants/* Spacings.SPACING_0B */.t8.NE,
    spread: "10px",
    color: "rgba(235,87,87, 0)"
}), ";}100%{box-shadow:none;}", "ShadowPulse");
var LeftIcon_Play = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(PlayCircleBig/* default */.Z, {
    target: "e1xvnchw0",
    label: "Play"
})("margin-right:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";");
var LeftIcon_Live = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(PlayCircleBig/* default */.Z, {
    target: "e1xvnchw1",
    label: "Live"
})("margin-right:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";border-radius:50%;box-shadow:", (0,boxShadowGenerator/* default */.Z)({
    yOffset: styleConstants/* Spacings.SPACING_0B */.t8.NE,
    blur: styleConstants/* Spacings.SPACING_0B */.t8.NE,
    color: "rgba(235,87,87, 0.4)"
}), ";animation:", LeftIcon_ShadowPulse, " 2s infinite;:hover{animation:none;}");
var LiveQuiz = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("img", {
    target: "e1xvnchw2",
    label: "LiveQuiz"
})("margin-right:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";height:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";width:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";border-radius:50%;user-drag:none;user-select:none;box-shadow:", (0,boxShadowGenerator/* default */.Z)({
    yOffset: styleConstants/* Spacings.SPACING_0B */.t8.NE,
    blur: styleConstants/* Spacings.SPACING_0B */.t8.NE,
    color: "rgba(235,87,87, 0.4)"
}), ";animation:", LeftIcon_ShadowPulse, " 2s infinite;:hover{animation:none;}");
var DoneCircle = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(CheckBig/* default */.Z, {
    target: "e1xvnchw3",
    label: "DoneCircle"
})("margin-right:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";");
var Quiz = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("img", {
    target: "e1xvnchw4",
    label: "Quiz"
})("margin-right:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";height:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";width:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";user-drag:none;user-select:none;");
var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1xvnchw5",
    label: "Wrapper"
})("display:flex;flex-direction:column;margin-right:", function(param) {
    var $isRecordedBatchLesson = param.$isRecordedBatchLesson;
    return $isRecordedBatchLesson ? styleConstants/* Spacings.SPACING_4B */.t8.BM : styleConstants/* Spacings.SPACING_6B */.t8.BY;
}, ";width:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";@media only screen and (max-width:47.95em){margin-right:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";height:", function(param) {
    var $isRecordedBatchLesson = param.$isRecordedBatchLesson;
    return $isRecordedBatchLesson ? "unset" : "47px";
}, ";}");
var LeftIcon_Month = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H7/* default */.Z, {
    target: "e1xvnchw6",
    label: "Month"
})("color:", function(param) {
    var $isRecordedBatchLesson = param.$isRecordedBatchLesson;
    return $isRecordedBatchLesson ? "var(--color-i-gray-13)" : "";
}, ";font-size:", function(param) {
    var $isRecordedBatchLesson = param.$isRecordedBatchLesson;
    return $isRecordedBatchLesson ? styleConstants/* Fonts.EXTRA_SMALL */.F3.y2 : "";
}, ";width:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";text-align:center;text-transform:uppercase;");
var MonthDateWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1xvnchw7",
    label: "MonthDateWrapper"
})("background-color:", function(param) {
    var $isRecordedBatchLesson = param.$isRecordedBatchLesson;
    return $isRecordedBatchLesson ? "var(--color-i-violet-dark-1)" : "";
}, ";border-radius:", function(param) {
    var $isRecordedBatchLesson = param.$isRecordedBatchLesson;
    return $isRecordedBatchLesson ? styleConstants/* Spacings.SPACING_2B */.t8.Rw : "";
}, ";padding-top:", function(param) {
    var $isRecordedBatchLesson = param.$isRecordedBatchLesson;
    return $isRecordedBatchLesson ? styleConstants/* Spacings.SPACING_5 */.t8.$N : "";
}, ";padding-bottom:", function(param) {
    var $isRecordedBatchLesson = param.$isRecordedBatchLesson;
    return $isRecordedBatchLesson ? styleConstants/* Spacings.SPACING_5 */.t8.$N : "";
}, ";");
var LeftIcon_Day = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H4/* default */.Z, {
    target: "e1xvnchw8",
    label: "Day"
})("text-align:center;color:var(--color-text-primary);font-size:", function(param) {
    var $isRecordedBatchLesson = param.$isRecordedBatchLesson;
    return $isRecordedBatchLesson ? styleConstants/* Fonts.H6 */.F3.H6 : "";
}, ";margin-top:", function(param) {
    var $isRecordedBatchLesson = param.$isRecordedBatchLesson;
    return $isRecordedBatchLesson ? styleConstants/* Spacings.SPACING_1B */.t8.MK : 0;
}, ";@media only screen and (max-width:47.95em){font-size:", function(param) {
    var $isRecordedBatchLesson = param.$isRecordedBatchLesson;
    return $isRecordedBatchLesson ? styleConstants/* Fonts.H6 */.F3.H6 : "18px";
}, ";}");
var IconWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1xvnchw9",
    label: "IconWrapper"
})("background-color:", function(param) {
    var $bgColor = param.$bgColor;
    return $bgColor;
}, ";border-radius:100%;height:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";width:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";display:flex;align-items:center;justify-content:center;");
var StyLinearProgressBar = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(LinearProgressBar/* default */.Z, {
    target: "e1xvnchw10",
    label: "StyLinearProgressBar"
})("margin-top:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var quizState = function(lesson) {
    var currentDate = new Date();
    var val = dates/* default.compareDates */.ZP.compareDates(lesson.startsAt, currentDate);
    if (val === -1) return constants/* sessionStates.FUTURE */.A_.FUTURE;
    if (val === 1) return constants/* sessionStates.PAST */.A_.PAST;
};
var getIconColor = function(lesson, isCompleted) {
    var ref, ref1;
    var ref2 = ((ref = lesson.topicGroups) === null || ref === void 0 ? void 0 : ref[0]) || {}, topicGroupTitle = ref2.title;
    if (!topicGroupTitle) {
        return {
            bgColor: "var(--color-i-green-8)",
            iconColor: "var(--color-white)"
        };
    }
    var topicColor = (ref1 = (0,getTopicGroupAssetObj/* default */.Z)(topicGroupTitle)) === null || ref1 === void 0 ? void 0 : ref1.color;
    var colorObj = {
        bgColor: topicColor,
        iconColor: "var(--color-white)"
    };
    if (isCompleted) {
        return {
            bgColor: (0,ChapterInfo/* hexToRgb */.o)(topicColor),
            iconColor: topicColor
        };
    }
    return colorObj;
};
var renderLeft = function(param) {
    var lesson = param.lesson, showDate = param.showDate, isEducatorSide = param.isEducatorSide, isRecordedBatchLesson = param.isRecordedBatchLesson;
    var state = lesson.state, liveAt = lesson.liveAt, hasWatched = lesson.hasWatched, lessonDuration = lesson.lessonDuration, watchTime = lesson.watchTime, type = lesson.type, latestSession = lesson.latestSession, startsAt = lesson.startsAt, secondsBeforeLive = lesson.secondsBeforeLive, classType = lesson.classType;
    var colorConfig = getIconColor(lesson, hasWatched);
    var playButtonColor = isRecordedBatchLesson ? colorConfig.bgColor : "var(--color-i-green)";
    var liveTestIcon = "store/test-series/test-card-live-icon.svg";
    if (isEducatorSide) {
        if (classType === CreatePlusCourse_constants/* RECORDED_CLASS_VALUE */.Pz) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayCircleBig/* default */.Z, {
            size: "40px",
            color: "var(--color-text-secondary)"
        });
        if (showDate || Item/* default.classDidNotHappen */.ZP.classDidNotHappen(lesson, 3600 * 1000) || Item/* default.isUpcoming */.ZP.isUpcoming(lesson)) {
            var live = liveAt ? new Date(liveAt) : new Date(startsAt);
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LeftIcon_Month, {
                        $isRecordedBatchLesson: isRecordedBatchLesson,
                        children: live ? live.toLocaleString("default", {
                            month: "short"
                        }) : ""
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LeftIcon_Day, {
                        $isRecordedBatchLesson: isRecordedBatchLesson,
                        children: live ? live === null || live === void 0 ? void 0 : live.getDate() : ""
                    })
                ]
            });
        }
    } else if (!isEducatorSide && isRecordedBatchLesson && type === "post" && state === constants/* sessionStates.PAST */.A_.PAST && !watchTime) {
        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LeftIcon_Play, {
            size: "40px",
            color: playButtonColor
        });
    } else if (!isEducatorSide) {
        if (showDate || type === "post" && state === constants/* sessionStates.FUTURE */.A_.FUTURE && secondsBeforeLive > 900 || type === "quiz" && quizState(lesson) === constants/* sessionStates.FUTURE */.A_.FUTURE || Item/* default.isCompletedWithNoVideoUrl */.ZP.isCompletedWithNoVideoUrl(lesson) || Item/* default.classDidNotHappen */.ZP.classDidNotHappen(lesson)) {
            var live1 = liveAt ? new Date(liveAt) : new Date(startsAt);
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MonthDateWrapper, {
                    $isRecordedBatchLesson: isRecordedBatchLesson,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LeftIcon_Month, {
                            $isRecordedBatchLesson: isRecordedBatchLesson,
                            children: live1 ? live1.toLocaleString("default", {
                                month: "short"
                            }) : ""
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LeftIcon_Day, {
                            $isRecordedBatchLesson: isRecordedBatchLesson,
                            children: live1 ? live1 === null || live1 === void 0 ? void 0 : live1.getDate() : ""
                        })
                    ]
                })
            });
        }
    }
    if (isEducatorSide && Item/* default.isLessonLive */.ZP.isLessonLive(lesson, 3600 * 1000) && Item/* default.isPost */.ZP.isPost(lesson)) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LeftIcon_Live, {
        size: "40px",
        color: "var(--color-i-red)"
    });
    if (isEducatorSide && Item/* default.isLessonLive */.ZP.isLessonLive(lesson, 3600 * 1000) && !Item/* default.isPost */.ZP.isPost(lesson)) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LiveQuiz, {
        src: (0,imageHelper/* getImage */.gJ)("liveTest.svg"),
        alt: "quiz"
    });
    if (isEducatorSide && type === "post" && state === constants/* sessionStates.PAST */.A_.PAST) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DoneCircle, {
        size: "40px",
        color: "var(--color-text-secondary)"
    });
    if (isEducatorSide && type === "quiz" && quizState(lesson) === constants/* sessionStates.PAST */.A_.PAST) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DoneCircle, {
        size: "40px",
        color: "var(--color-text-secondary)"
    });
    if (!isEducatorSide && Item/* default.isLessonLive */.ZP.isLessonLive(lesson) && !Item/* default.isPost */.ZP.isPost(lesson)) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LiveQuiz, {
        src: (0,imageHelper/* getImage */.gJ)("liveTests.svg"),
        alt: "quiz"
    });
    if (!isEducatorSide && type === "quiz" && latestSession) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DoneCircle, {
        size: "40px",
        color: "var(--color-i-orange-1)"
    });
    if (!isEducatorSide && type === "quiz" && quizState(lesson) === constants/* sessionStates.PAST */.A_.PAST) {
        if (isRecordedBatchLesson) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Quiz, {
                src: (0,imageHelper/* getImage */.gJ)(liveTestIcon),
                alt: "quiz"
            });
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Quiz, {
            src: (0,imageHelper/* getImage */.gJ)("quiz.png"),
            alt: "quiz"
        });
    }
    if (!isEducatorSide && Item/* default.isLessonLive */.ZP.isLessonLive(lesson) && Item/* default.isPost */.ZP.isPost(lesson)) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LeftIcon_Live, {
        size: "40px",
        color: "var(--color-i-red)"
    });
    if (hasWatched) return isRecordedBatchLesson ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, {
        $bgColor: colorConfig.bgColor,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Play/* default */.Z, {
            size: "13px",
            color: colorConfig.iconColor
        })
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DoneCircle, {
        size: "40px",
        color: "var(--color-i-green)"
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LeftIcon_Play, {
                size: "40px",
                color: playButtonColor
            }),
            watchTime ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyLinearProgressBar, {
                value: Math.max(watchTime * 100 / lessonDuration, 10),
                width: isRecordedBatchLesson ? "36px" : "40px",
                height: "3px",
                backgroundColor: "var(--color-divider)",
                overlayColor: playButtonColor
            }) : null
        ]
    });
};
var LeftIcon = function(param) {
    var lesson = param.lesson, showDate = param.showDate, isBatchGroup = param.isBatchGroup, _isRecordedBatchLesson = param.isRecordedBatchLesson, isRecordedBatchLesson = _isRecordedBatchLesson === void 0 ? false : _isRecordedBatchLesson;
    var isEducatorSide = (0,useEducatorContext/* default */.Z)();
    if (isBatchGroup) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BatchGroup_BatchGroupLeftIcon, {
                lesson: lesson
            })
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
        $isRecordedBatchLesson: isRecordedBatchLesson,
        children: renderLeft({
            lesson: lesson,
            showDate: showDate,
            isEducatorSide: isEducatorSide,
            isBatchGroup: isBatchGroup,
            isRecordedBatchLesson: isRecordedBatchLesson
        })
    });
};
/* harmony default export */ var Course_LeftIcon = (LeftIcon);
LeftIcon.propTypes = {
    lesson: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    showDate: (prop_types_default()).bool,
    isBatchGroup: (prop_types_default()).bool
};
LeftIcon.defaultProps = {
    showDate: false,
    isBatchGroup: false
};


/***/ }),

/***/ 17192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var CheckBig = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M80 40c0 22.091-17.909 40-40 40s-40-17.909-40-40c0-22.091 17.909-40 40-40s40 17.909 40 40zM31.331 57.066c0.456 0.19 0.946 0.286 1.44 0.284 0.511-0.001 1.015-0.111 1.481-0.322 0.452-0.205 0.857-0.5 1.19-0.868l27.21-27.176c0.702-0.703 1.097-1.656 1.097-2.65 0-0.991-0.392-1.942-1.091-2.645-0.345-0.353-0.757-0.633-1.212-0.825-0.457-0.193-0.949-0.292-1.445-0.292s-0.987 0.099-1.445 0.292c-0.454 0.192-0.866 0.472-1.211 0.824l-24.58 24.548-10.146-10.083c-0.711-0.663-1.651-1.023-2.623-1.006s-1.898 0.411-2.585 1.098c-0.687 0.687-1.081 1.614-1.098 2.585s0.343 1.912 1.006 2.623l0.015 0.016 12.78 12.78c0.347 0.351 0.761 0.629 1.216 0.818z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CheckBig);


/***/ }),

/***/ 1218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var MoreVert = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M45.333 40c0 2.946-2.388 5.333-5.333 5.333s-5.333-2.388-5.333-5.333c0-2.946 2.388-5.333 5.333-5.333s5.333 2.388 5.333 5.333zM45.333 18.667c0 2.946-2.388 5.333-5.333 5.333s-5.333-2.388-5.333-5.333c0-2.946 2.388-5.333 5.333-5.333s5.333 2.388 5.333 5.333zM45.333 61.333c0 2.946-2.388 5.333-5.333 5.333s-5.333-2.388-5.333-5.333c0-2.946 2.388-5.333 5.333-5.333s5.333 2.388 5.333 5.333z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (MoreVert);


/***/ }),

/***/ 26459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var PlayCircleBig = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M40 0c-7.911 0-15.645 2.346-22.223 6.741s-11.705 10.642-14.732 17.951c-3.028 7.309-3.82 15.352-2.276 23.111s5.353 14.887 10.947 20.481c5.594 5.594 12.721 9.404 20.481 10.947s15.802 0.751 23.111-2.276c7.309-3.028 13.556-8.155 17.951-14.733s6.741-14.311 6.741-22.223c-0.011-10.605-4.229-20.773-11.728-28.272s-17.667-11.717-28.272-11.728v0zM55.344 43.61l-18.174 10.461c-0.621 0.369-1.329 0.567-2.051 0.575-0.736-0-1.459-0.199-2.092-0.575-0.634-0.356-1.161-0.874-1.529-1.501s-0.562-1.341-0.564-2.068v-21.005c0.001-0.727 0.196-1.44 0.564-2.068s0.895-1.145 1.529-1.501c0.624-0.36 1.331-0.55 2.051-0.55s1.428 0.19 2.051 0.55l18.174 10.461c0.651 0.351 1.195 0.873 1.575 1.508s0.58 1.362 0.58 2.102-0.2 1.466-0.58 2.102c-0.379 0.635-0.923 1.157-1.575 1.508h0.041z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (PlayCircleBig);


/***/ }),

/***/ 77729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);
/* harmony import */ var _utils_createStoreSelector__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83909);




var useStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(set) {
    return {
        showSummary: false,
        finishSummary: {},
        toggleShowSummary: function() {
            set(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                    showSummary: !state.showSummary
                });
            });
        },
        setFinishSummary: function(data) {
            set(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                    finishSummary: data
                });
            });
        },
        clearData: function() {
            set(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                    showSummary: false,
                    finishSummary: {}
                });
            });
        }
    };
});
var useFinishSummary = (0,_utils_createStoreSelector__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(useStore);
/* harmony default export */ __webpack_exports__["Z"] = (useFinishSummary);


/***/ }),

/***/ 20647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export practiceStore */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var zustand_vanilla__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59148);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14671);
/* harmony import */ var _constants_empty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59375);





var practiceStore = (0,zustand_vanilla__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(set) {
    return {
        practiceSessionReport: _constants_empty__WEBPACK_IMPORTED_MODULE_0__/* .emptyObject */ .FD,
        isPlanner: false,
        finishPlannerPracticeSession: function(sessionReport, isPlanner) {
            return set(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state), {
                    isPlanner: isPlanner,
                    practiceSessionReport: sessionReport
                });
            });
        }
    };
});
var usePracticeStore = (0,zustand__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(practiceStore);
/* harmony default export */ __webpack_exports__["Z"] = (usePracticeStore);


/***/ }),

/***/ 83909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var zustand_shallow__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60374);

// Selector ref: https://github.com/pmndrs/zustand/wiki/Auto-Generating-Selectors
// Shallow store ref: https://github.com/pmndrs/zustand#selecting-multiple-state-slices
// To get the property/action: const propertyName = useStore.use.propertyName()
function createStoreSelectors(store) {
    store.use = {};
    Object.keys(store.getState()).forEach(function(key) {
        var selector = function(state) {
            return state[key];
        };
        store.use[key] = function() {
            return store(selector, zustand_shallow__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);
        };
    });
    return store;
}
/* harmony default export */ __webpack_exports__["Z"] = (createStoreSelectors);


/***/ }),

/***/ 23018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hm": function() { return /* binding */ goBack; },
/* harmony export */   "Ox": function() { return /* binding */ getDoubtSolutionsHomeTags; },
/* harmony export */   "ZM": function() { return /* binding */ getFreeCourseTags; },
/* harmony export */   "fu": function() { return /* binding */ getCatalogueQuetionsHomeTag; },
/* harmony export */   "ll": function() { return /* binding */ getClass; },
/* harmony export */   "rs": function() { return /* binding */ getCatalogueDetailsHomeTags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _models_Topology__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34482);
/* harmony import */ var _models_Course__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56046);
/* harmony import */ var _api_hooks_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61059);
/* harmony import */ var _textHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31309);

/* eslint-disable max-lines */ 



var getClass = function() {
    var item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isGTP = arguments.length > 1 ? arguments[1] : void 0;
    var ref;
    var _programme = item.programme, programme = _programme === void 0 ? {} : _programme;
    var goal = programme.goal, courseName = programme.name;
    if (!goal) return [];
    if (item.isSpecial || ((ref = item.programme) === null || ref === void 0 ? void 0 : ref.isSpecial)) {
        var tags = [
            {
                title: goal.name,
                as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
            }
        ];
        tags.push(isGTP ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: "Free Classes"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getGtpFreeClassesAllLink */ .v9)(goal)) : {
            title: "Free classes & tests",
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getSpecialClassesLink */ .Lb)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getSpecialClassesLinkHref */ .EN)()
        });
        return tags;
    }
    var tags1 = [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        }
    ];
    if (!isGTP) {
        tags1.push({
            title: courseName,
            as: (0,_models_Course__WEBPACK_IMPORTED_MODULE_1__/* .getLink */ .Rg)(programme),
            href: (0,_models_Course__WEBPACK_IMPORTED_MODULE_1__/* .getLinkPath */ .bc)(programme)
        });
    }
    return tags1;
};
var getDoubtSolutionsHomeTags = function(goal) {
    var // eslint-disable-next-line no-unused-vars
    ctlgData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, // eslint-disable-next-line no-unused-vars
    ctlgItemData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, isOfflineSubscription = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (!goal) return;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        }
    ];
};
var getCatalogueQuetionsHomeTag = function(goal, ctlgData) {
    var // eslint-disable-next-line no-unused-vars
    ctlgItemData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, isOfflineSubscription = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (!goal) return;
    var ctlgSlug = ctlgData.ctlgSlug, ctlgUID = ctlgData.ctlgUID, ctlgTitle = ctlgData.ctlgTitle;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: "Doubt Solving",
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/doubts-and-solutions/"),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/doubts-and-solutions/")
        },
        {
            title: ctlgTitle,
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/doubts-and-solutions/").concat(ctlgSlug, "/").concat(ctlgUID),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/doubts-and-solutions/[catalogSlug]/[catalogUID]")
        }
    ];
};
var getCatalogueDetailsHomeTags = function(goal) {
    var // eslint-disable-next-line no-unused-vars
    ctlgData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, // eslint-disable-next-line no-unused-vars
    ctlgItemData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, isOfflineSubscription = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (!goal) return;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: "Doubts & solutions",
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/doubts-and-solutions/"),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/doubts-and-solutions/")
        }
    ];
};
var getPlusTopicsTags = function(goal) {
    var isOfflineSubscription = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (!goal) return;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        }
    ];
};
var getPlatformBatchTopicsTags = function(goal) {
    if (!goal) return [];
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        }
    ];
};
var getBatchTags = function(goal) {
    var isOfflineSubscription = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, isStoreRoute = arguments.length > 2 ? arguments[2] : void 0;
    if (!goal) return;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    var as = (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal);
    var href = (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)();
    return isStoreRoute ? [
        {
            title: goal.name,
            as: "".concat(as, "/store"),
            href: "".concat(href, "/store")
        },
        {
            title: "Batches",
            as: "".concat(as, "/store"),
            href: "".concat(href, "/store")
        }
    ] : [
        {
            title: goal.name,
            as: as,
            href: href
        },
        {
            title: title,
            as: as,
            href: href
        },
        {
            title: "Batches",
            as: "".concat(as, "/batches"),
            href: "".concat(href, "/batches")
        }
    ];
};
var getYoutubeLessonTags = function(goal, data) {
    if (!goal) return;
    return [
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: goal.name
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getYoutubeCourseLink */ .bU)(data)),
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: "Free courses"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getYoutubeCourseLink */ .bU)(data)),
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: data.playlistName
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getYoutubeLessonLink */ ._Y)(data))
    ];
};
var getYoutubeCourseTags = function(goal) {
    if (!goal) return;
    return [
        {
            title: goal.name,
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal)),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)())
        },
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: "Free courses"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getYoutubeCourseLink */ .bU)({
            goalUID: goal.uid
        }))
    ];
};
var getGoalAndFreeTagsOfFreeTopic = function(goal) {
    if (!goal) return;
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: "Free courses",
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/free-platform"),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/free-platform")
        }
    ];
};
var getGoalTopicsTitle = function(goal, isGTP) {
    if (goal.isNoTestGoal) return "Key concepts";
    if (isGTP) return "Video lessons";
    return "Syllabus";
};
var getTopics = function(goal) {
    var isGTP = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!goal) return;
    return [
        {
            // eslint-disable-next-line no-nested-ternary
            title: getGoalTopicsTitle(goal, isGTP),
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/topics"),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/topics")
        }
    ];
};
var getTopologyTags = function(topology, goal) {
    if (!topology || !goal) return;
    return [
        {
            title: topology.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicLink */ .pA)(topology, goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicLinkHref */ .BR)()
        }
    ];
};
var getEducatorTag = function(author, educatorUsername) {
    if (!author) return;
    return [
        {
            title: (0,_api_hooks_utils__WEBPACK_IMPORTED_MODULE_2__/* .getFullName */ .P)(author.firstName, author.lastName),
            as: "/@".concat(educatorUsername),
            href: "/[authorID]"
        }
    ];
};
var getCourseTags = function(goal, topicGroup) {
    var isOfflineSubscription = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    if (!goal) return [];
    var title = isOfflineSubscription ? "Centre" : "Plus";
    var Tags = [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        }
    ];
    if (topicGroup) {
        Tags.push({
            title: "Syllabus",
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListLink */ .dF)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListHref */ .s3)()
        }, {
            title: topicGroup.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicLink */ .pA)(topicGroup, goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkPath */ .bc)()
        });
    }
    return Tags;
};
var getFreeCourseTags = function(goal, topologies) {
    var ref;
    if (!(goal === null || goal === void 0 ? void 0 : goal.uid)) return [];
    var ref1 = (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getHrefAndAsOfAFreeCourse */ .Ho)(goal), href = ref1.href, as = ref1.as;
    var Tags = [
        {
            title: goal.name,
            href: href,
            as: as
        },
        {
            title: "Free courses",
            href: href,
            as: as
        }
    ];
    if (topologies === null || topologies === void 0 ? void 0 : (ref = topologies.parent) === null || ref === void 0 ? void 0 : ref.parent) {
        Tags.push({
            title: topologies.parent.parent.name,
            as: "/goal/".concat(goal.goalSlug, "/").concat(goal.uid, "/free-platform/").concat(topologies.parent.parent.slug || (0,_textHelper__WEBPACK_IMPORTED_MODULE_3__/* .getStringWordsJoinedWith */ .kL)(topologies.parent.parent.name, "-"), "/").concat(topologies.parent.parent.uid),
            href: "/goal/[goalSlug]/[goalUID]/free-platform/[topicSlugType]/[topicSlugUID] "
        });
        Tags.push({
            title: topologies.parent.name,
            as: "/goal/".concat(goal.goalSlug, "/").concat(goal.uid, "/free-platform/").concat(topologies.parent.parent.slug || (0,_textHelper__WEBPACK_IMPORTED_MODULE_3__/* .getStringWordsJoinedWith */ .kL)(topologies.parent.parent.name, "-"), "/").concat(topologies.parent.slug || (0,_textHelper__WEBPACK_IMPORTED_MODULE_3__/* .getStringWordsJoinedWith */ .kL)(topologies.parent.name, "-"), "/").concat(topologies.parent.uid),
            href: "/goal/[goalSlug]/[goalUID]/free-platform/[topicSlugType]/[topicSlugUID]/[conceptUID] "
        });
    }
    return Tags;
};
var getTestSeriesTags = function(goal) {
    var isOfflineSubscription = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (!goal) return [];
    var title = isOfflineSubscription ? "Centre" : "Plus";
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: "Test series",
            href: "/goal/[goalSlug]/[goalUID]/test-series",
            as: "/goal/".concat(goal.slug, "/").concat(goal.uid, "/test-series")
        }
    ];
};
var getPlatformSeeAllTags = function(seeAllType, goal, topicGroup) {
    var hasSubscription = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, pageType = arguments.length > 4 ? arguments[4] : void 0, isOfflineSubscription = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
    var seeAllLinks = null;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    if (seeAllType === "specialClass") {
        seeAllLinks = [
            {
                title: goal.name,
                as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
            },
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: "Free classes & tests"
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getSpecialClassesAllLink */ .Po)(goal))
        ];
        return seeAllLinks;
    }
    if (seeAllType === "goal" && !hasSubscription) {
        if ([
            "educators",
            "batches",
            "upcoming",
            "recently_started",
            "popular_courses"
        ].includes(pageType)) {
            seeAllLinks = [
                {
                    title: goal.name,
                    as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                    href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
                }
            ];
            return seeAllLinks;
        }
    }
    if (seeAllType === "goal" || seeAllType === "enrolled") {
        seeAllLinks = [
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: goal.name
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: title
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal))
        ];
        return seeAllLinks;
    }
    if (seeAllType === "freeCourses") {
        seeAllLinks = [
            {
                title: goal.name,
                as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
            },
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: "Free"
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getHrefAndAsOfAFreeCourse */ .Ho)(goal))
        ];
        return seeAllLinks;
    }
    return [
        {
            title: goal.name
        },
        {
            title: title
        },
        {
            title: "Syllabus",
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListLink */ .dF)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListHref */ .s3)()
        },
        {
            title: topicGroup.name,
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicLink */ .pA)(topicGroup, goal),
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkPath */ .bc)()
        }
    ];
};
var getSeeAllTags = function(seeAllType, goal, topicGroup) {
    var hasSubscription = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, pageType = arguments.length > 4 ? arguments[4] : void 0, isGTP = arguments.length > 5 ? arguments[5] : void 0, isOfflineSubscription = arguments.length > 6 ? arguments[6] : void 0;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    var seeAllLinks = null;
    if (seeAllType === "enrolledBatches") {
        seeAllLinks = [
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: goal.name
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getPannerLink */ .vx)(goal))
        ];
        return seeAllLinks;
    }
    if (seeAllType === "specialClass") {
        seeAllLinks = [
            {
                title: goal.name,
                as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
            }
        ];
        seeAllLinks.push(isGTP ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: "Free Classes"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getGtpFreeClassesAllLink */ .v9)(goal)) : (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: "Free classes & tests"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getSpecialClassesAllLink */ .Po)(goal)));
        return seeAllLinks;
    }
    if (seeAllType === "goal" && !hasSubscription) {
        if ([
            "educators",
            "batches",
            "upcoming",
            "recently_started",
            "popular_courses"
        ].includes(pageType)) {
            seeAllLinks = [
                {
                    title: goal.name,
                    as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                    href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
                },
                {
                    title: "Browse",
                    as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/browse"),
                    href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal), "/browse")
                }
            ];
            return seeAllLinks;
        }
    }
    if (seeAllType === "goal" || seeAllType === "enrolled") {
        seeAllLinks = [
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: (goal === null || goal === void 0 ? void 0 : goal.name) || ""
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: title
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal))
        ];
        return seeAllLinks;
    }
    if (seeAllType === "freeCourses") {
        seeAllLinks = [
            {
                title: (goal === null || goal === void 0 ? void 0 : goal.name) || "",
                as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
            },
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: "Free"
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getHrefAndAsOfAFreeCourse */ .Ho)(goal))
        ];
        return seeAllLinks;
    }
    if (seeAllType === "enrolledCourses") {
        seeAllLinks = [
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: (goal === null || goal === void 0 ? void 0 : goal.name) || ""
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: title
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
            {
                title: "Enrolled",
                href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/enrolled"),
                as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/enrolled")
            }
        ];
        return seeAllLinks;
    }
    return [
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: (goal === null || goal === void 0 ? void 0 : goal.name) || ""
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: title
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
        {
            title: "Syllabus",
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListLink */ .dF)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListHref */ .s3)()
        },
        {
            title: topicGroup.name,
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicLink */ .pA)(topicGroup, goal),
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkPath */ .bc)()
        }
    ];
};
var getSavedTag = function(goal) {
    if (!goal) return [];
    return [
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: "Saved"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getHrefAndAsOfSaved */ .vX)(goal))
    ];
};
var goBack = function() {
    return window.history.back();
};
var getDriveTags = function(ancestors) {
    if (!ancestors || !Array.isArray(ancestors)) return [];
    return ancestors.map(function(item) {
        var isRoot = (item === null || item === void 0 ? void 0 : item.name) === "root";
        return {
            title: isRoot ? "Cloud" : item === null || item === void 0 ? void 0 : item.name,
            as: isRoot ? "/educator/drive" : "/educator/drive/folder/".concat(item === null || item === void 0 ? void 0 : item.uid),
            href: isRoot ? "/educator/drive" : "/educator/drive/folder/[itemUID]"
        };
    });
};
var getFreeLiveClassesTags = function(goal) {
    if (!goal) return;
    var as = (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal);
    var href = (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)();
    return [
        {
            title: goal.name,
            as: as,
            href: href
        },
        {
            title: "Free live classes",
            as: "".concat(as, "/classes"),
            href: "".concat(href, "/classes")
        }
    ];
};
var breadcrumbs = {
    getClass: getClass,
    goBack: goBack,
    getPlusTopicsTags: getPlusTopicsTags,
    getTopologyTags: getTopologyTags,
    getTopics: getTopics,
    getCourseTags: getCourseTags,
    getTestSeriesTags: getTestSeriesTags,
    getSeeAllTags: getSeeAllTags,
    getFreeCourseTags: getFreeCourseTags,
    getGoalAndFreeTagsOfFreeTopic: getGoalAndFreeTagsOfFreeTopic,
    getBatchTags: getBatchTags,
    getSavedTag: getSavedTag,
    getDriveTags: getDriveTags,
    getDoubtSolutionsHomeTags: getDoubtSolutionsHomeTags,
    getCatalogueQuetionsHomeTag: getCatalogueQuetionsHomeTag,
    getCatalogueDetailsHomeTags: getCatalogueDetailsHomeTags,
    getPlatformSeeAllTags: getPlatformSeeAllTags,
    getPlatformBatchTopicsTags: getPlatformBatchTopicsTags,
    getEducatorTag: getEducatorTag,
    getYoutubeLessonTags: getYoutubeLessonTags,
    getYoutubeCourseTags: getYoutubeCourseTags,
    getFreeLiveClassesTags: getFreeLiveClassesTags
};
/* harmony default export */ __webpack_exports__["ZP"] = (breadcrumbs);


/***/ }),

/***/ 9233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ getSavedQuestionTitle; },
/* harmony export */   "D": function() { return /* binding */ getSavedContentType; }
/* harmony export */ });
/* harmony import */ var _utils_isObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36552);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43135);


var getSavedContentType = function(entityType) {
    if (entityType === _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .savedObjectTypes.LESSON */ .cc.LESSON) return "Lesson";
    if (entityType === _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .savedObjectTypes.TEST */ .cc.TEST) return "Test";
    if (entityType === _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .savedObjectTypes.QUESTION */ .cc.QUESTION) return "Question";
    if (entityType === _constants_index__WEBPACK_IMPORTED_MODULE_0__/* .savedObjectTypes.NOTES */ .cc.NOTES) return "Notes";
    return "";
};
var getSavedQuestionTitle = function(param) {
    var _question = param.question, question = _question === void 0 ? {} : _question, hasComprehension = param.hasComprehension, selectedLanguage = param.selectedLanguage;
    return hasComprehension && ((0,_utils_isObject__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(question.comprehension) ? question.comprehension[selectedLanguage] : question.comprehension) || !hasComprehension && ((0,_utils_isObject__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(question.content) ? question.content[selectedLanguage] : question.content) || "";
};


/***/ })

}]);